import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import MD5 from "./lib/md5";
import io from "socket.io-client";
import util from "./lib/util";
import router from "./router";
import * as moment from "moment-timezone";
const CancelToken = axios.CancelToken;
let source = CancelToken.source();
export let ipcRenderer;

if (isElectron()) {
  ipcRenderer = (window as any).require("electron").ipcRenderer;
  ipcRenderer.send("imReady", "");
  ipcRenderer.on("loadContactFromNotification", async (event, arg) => {
    const creds = (ipcRenderer as any).sendSync("get-creds");
    await store.dispatch("relogin", creds);
    await store.dispatch("getDevices");
    // console.log('json data:', arg.jsonData);
    processCall(arg.jsonData);
  });
}

axios.interceptors.response.use(
  function (response) {
    if (response.headers.token) {
      store.commit("SET_JWT", response.headers.token);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
Vue.use(Vuex);

export const AppSettings = {
  //API_HOST: 'http://localhost:3000/',  //// Local b
  //API_HOST: "http://lou-dev-dash-web1.hellospoke.com:3000/",
  //API_HOST: "https://lou-dev-dash-lb-web.hellospoke.com/",
  API_HOST: "https://dashboard.hellospoke.com/", ////production
  // API_HOST: 'https://34.215.199.143/', ////Dev
  //API_HOST: 'https://dev-dash.hellospoke.com/' ,  ////production
  //API_HOST:'https://54.191.105.176/' ,// development
  // API_HOST:'https://34.220.88.30/' ,// QA environment

  // API_HOST:'http://54.191.105.176:3000/' ,// development for testing on cmd
  //API_HOST: 'https://staging-dash.hellospoke.com/', ////Staging
  // API_HOST: 'http://54.201.254.117:3000/',///old Production
  // API_HOST: 'https://34.212.253.243/',///new Production
  // This is used in the admin area to determine the root account for all the children
  // accounts in the Admin area. When reading the documentation I couldn't decide whether
  // they wanted all children of the Voitress account, or just the children of the user's account.
  // If it ends up they only want children of the user I can move this into the store rather than
  // have it be constant.
  Voitress_Kazoo_ID: 0,
  cdr_query_limit: 150,
  //websocketServer: 'https://34.215.199.143:3333',
  // websocketServer: 'http://localhost:4000',
  //websocketServer: 'https://34.212.253.243:3333',
  //  websocketServer: 'https://dev-dash.hellospoke.com:3333',
  // websocketServer: 'https://staging-ws.hellospoke.com:3333',
  websocketServer: "https://staging-ws.hellospoke.com:3333",
  AWS_MMS_BUCKET: "https://s3-us-west-2.amazonaws.com/spoke-mms/",
  MESSAGE_CHAR_LIMIT: 450,
};

export declare interface StoreState {
  account: AccountState;
  reports: ReportsState;
  dashboard: DashboardState;
  conference: ConferenceState;
}

declare interface Settings {
  enable_call_forward: boolean;
  vm_to_email_enabled: boolean;
  phone_number: string;
  email: string;
  ring_voip_phone: boolean;
  keep_caller_id: boolean;
}

declare interface Device {
  id: string;
  name: string;
  registered: boolean;
}

declare interface Voicemail {
  call_id: string;
  caller_id_name: string;
  caller_id_number: string;
  folder: string;
  from: string;
  length: number;
  media_id: string;
  timestamp: number;
  to: string;
}

declare interface AccountState {
  jwt: string;

  privilege_level: "user" | "manager" | "admin" | "voitress-admin";

  // Described in 3.2.1 and 5.7
  // "The user’s phone numbers and corresponding permissions levels can be
  // retrieved using a database view. This view will return all
  // the user’s information that is stored in the database User documents. This
  // includes a text_permissions key. This key will contain an array/list of phone
  // numbers and the user’s permissions level for each phone number. The phone
  // numbers text_permissions_levels should be used to enable/disable certain
  // functionality as described below."
  text_permissions: TextPermission[];

  admin_hellospoke_accounts: HellospokeAccount[];

  // Documents are used in both the Documents Tile and the Email Tile (attachments)
  documents: Document[];
  settings: Settings;
  devices: Device[];
  voicemails: Voicemail[];
  vm_id: string;
  my_call_history: object;
  my_call_history_load_more: boolean;
  my_call_history_loader: boolean;
  call_id?: string;
  encrypted_creds: string;
  account_name: string;
  account_id: string;
  logout_status: boolean;
}

export declare interface Document {
  id: string;
  name: string;
  size: number;
}

export declare interface TextPermission {
  phone_number: string;
  text_permissions_level: "none" | "read_only" | "full_access";
}

declare interface Text {
  id: string;
  content: string;
  direction: "in" | "out";
}

// From https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/accounts.md
// the fetch all descendants example towards the bottom of the page
declare interface HellospokeAccount {
  id: string;
  name: string;
  realm: string;
  tree: string[];
}

declare interface ReportsState {
  showReplaceModal: boolean;
  showDeleteModal: boolean;
  replaceFilename: string;
  callreport_Slide: boolean;
  currentFiltersHaveRun: boolean;
  P;
  filters: ReportsFilters;
  callReports: CDR[];
  callReportsHistory: CDR[];
  voicemail_records: CDR[];
  record_data: object;
  showLoadMoreBar: boolean;
  showProgress: boolean;
  download_spin: boolean;
  loadingMore: boolean;
  bookmark: string;
  report_sort: object;
  scheduleForm: ScheduleFormFields;
  scheduledReports: any[]; // TODO define this type
  total: number;
  monthyear: MonthYear[];
  monthyearindex: number;
  searchtext: string;
  searchtext_clear: boolean;
  voicedata_load: boolean;

  // TODO define this type
}

declare interface Note {
  id: string;
  content: string;
  last_updated: number;
  contact_id: string;
}
declare interface ConferenceState {
  isConferenceLoaded: boolean;
}

declare interface ConferecneParticipant {
  name: string;
  code: string;
  number: number;
  speak: boolean;
  hear: boolean;
  duration: number;
  talking: boolean;
  member_id: number;
  colorcode: any;
}
declare interface DashboardState {
  isIDLE: boolean;
  IsConferenceLoaded: boolean;
  ConferenceData: HelloSpokeConference;
  ConferenceUserList: HelloSpokeConferenceUser[];
  User_dashbord: HelloSpokeConferenceUser[];
  ConferecneParticipantList: ConferecneParticipant[];
  Confrence_On: boolean;
  AttendeeSectionList: AttendeeSection;
  Devices: any;
  Channels: any;
  OnGoinCalls: any;
  ConferenceDeviceList: HelloSpokeConferenceDevice[];
  selectedContact: HellospokeContact | KazooContact | null;
  selectedContact_menu: HellospokeContact | KazooContact | null;
  selectedContactOnCall: HellospokeContact | KazooContact | null;
  selectednotificationContact: HellospokeContact | KazooContact | null;
  contactsidebar_status: any;
  textmsgtab: any;
  oldsettaglist: any[];
  selectedmsghistory: any[];
  SharedContact_count: any;
  SharedContact_List: any[];
  from_textpanel_contact: boolean;
  PersonalContact_Count: any;
  PersonalContact_List: any[];
  FavoirteContact_Count: any;
  FavoirteContact_List: any[];
  companyContact_List: any[];
  PresenceContact_count: any;
  Contact_loader: boolean;
  Tag_status: boolean;
  handletagsidebar: boolean;
  Tab_Mang: any;
  Tab_Action: any;
  Managing_Tag: any;
  Tag_list: any[];
  contact_modalstatus: any;
  ismultipledelete: any;
  //create new tag
  NewTags: any[];
  contact_handler?: object;
  SharedContact_status: boolean;
  incomingCaller?: object;
  contacts: HellospokeContact[]; // Eventually this should be both Hellospoke and Kazoo contacts
  result_contacts: HellospokeContact[];
  selected_contact: HellospokeContact[];
  feedbackMessage: string;
  admin: AdminState;
  text_history: Text[];
  textmessage_limit: any;
  notes: Note[];
  note_status: boolean;
  isLoading_Note: boolean;
  call_history: {
    bookmarks: object;
    cdrs: CDR[];
  };
  call_history_load_more: boolean;
  call_history_loader: boolean;

  show_quick_call_modal: boolean;
  show_conference_modal: boolean;
  number_to_call: string;
  notifications: object[];
  notifiaction_ringtone: boolean;
  incommingmessagenotification: object[];
  blackhole_socket?: object;
  notifications_socket?: object;
  readnotifactionfrom_badge: boolean;
  readnotifactionfrom_notifModal: any;
  incoming_text: object;
  start_newtext: boolean;
  selectedfile: string;
  textpannel_contactinfo: string;
  notification_contactinfo: string;
  number_being_called: string;
  Onchange_textnumber: any;
  Onchange_textnumberstatus: boolean;
  newcontact_status: boolean;
  foucuson_text: "";
  load_more_text: boolean;
  newcontact_creat_Number: any;
  editcontact_status: boolean;
  contactdetail: boolean;
  contactstatusvm: boolean;
  notificationvmid: string;
  voice_notification: string;
  userfirstname: string;
  userlastname: string;
  logger_userid: string;
  logger_profile: string;
  contactlist_status: boolean;
  contact_info_loader: boolean;
  user_image_url: string;
  tagname: object[]; //string;
  userid: string;

  c: any;
  t: any;
  timer_is_on: any;
}

declare interface ReportsFilters {
  inboundChecked: boolean;
  inboundChecked_schedule: boolean;
  outboundChecked: boolean;
  outboundChecked_Schedule: boolean;
  answeredYes: boolean;
  answeredYes_schedule: boolean;
  answeredNo: boolean;
  answeredNo_schedule: boolean;
  startDate?: Date | null;
  endDate?: Date | null;

  extensionsList: Extension[];
  extensionsList_schedul: Extension[];
  extensionsList_selectAll: boolean;
  extensionsList_selectAllSchedul: boolean;
  startDate_Schedul?: Date | null;
  endDate_Schedul?: Date | null;

  assignedUserIds: string[];
  timezone: Timezone | null;
}

export declare interface CDR {
  id?: string;
  from_number?: string;
  to_number?: string;
  duration?: number;
  timestamp?: string;
  dialed_number?: string;
  to_name?: string;
  from_name?: string;
  call_recording?: string;
  call_direction?: string;
}

declare interface Extension {
  ext: string;
  external: string;
  value: boolean;
}

declare interface WeeklyDays {
  day: string;
  value: boolean;
}

export declare interface Timezone {
  abbrev: "ET" | "CT" | "MT" | "PT" | "";
  tz: string;
}

export declare interface MonthYear {
  month: string;
  year: string;
}

declare interface ScheduleFormFields {
  filename: string;
  email: string;
  dailyEnabled: boolean;
  weeklyEnabled: boolean;
  enabledDay: string;
  monthlyEnabled: boolean;
  monthlyDelivery: "first" | "fifteenth" | "last" | "none";
  weeklyTime: Date | null;
  dailyTime: Date | null;
  monthlyTime: Date | null;
  WeeklyDays_EnalbeList: WeeklyDays[];
}

declare interface ReportDataBundle {
  filters: ReportDataFilters;
  lucene_query: string;
  frequency: ReportDataFrequency;
  filename: string;
  email_address: string;
  report_id?: string;
  user_id?: string;
  account_id?: string;
  pvt_type: "scheduled_report";
  schedule_startDate?: Date | null;
  schedule_endDate?: Date | null;
}

declare interface ReportDataFilters {
  call_direction: "false" | "inbound" | "outbound" | "both";
  answered: "true" | "false" | "both";
  extensions: string[];
  email_address: string;
}

declare interface ReportDataFrequency {
  rate: "daily" | "weekly" | "monthly";
  hour: number | "*";
  day_of_month: number | "*";
  month?: number | "*";
  day_of_week: string[];
  timezone: "ET" | "CT" | "MT" | "PT" | "";
}

export interface Moderator {
  pins: any[];
  numbers: any[];
  join_muted: boolean;
  join_deaf: boolean;
}

export interface Member {
  pins: any[];
  numbers: any[];
  join_muted: boolean;
  join_deaf: boolean;
}

export interface ReadOnly {
  moderators: number;
  members: number;
  is_locked: boolean;
  duration: number;
}
export interface Markers {
  monster: Monster;
}
export interface Monster {
  source: String;
}

export interface HelloSpokeConference {
  _read_only: ReadOnly;
  markers: Markers;
  conference_numbers: string[];
  id: string;
  moderator: Moderator;
  member: Member;
  name: string;
  owner_id: string;
  play_entry_tone: boolean;
  play_exit_tone: boolean;
  play_name: boolean;
  play_name_on_join: boolean;
  auth_token: string;
}

export interface HelloSpokeConferenceUser {
  id: string;
  features: string[];
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  priv_level: string;
  presence_id: number;
  imageUrl: string;
}

export interface Attendee {
  id: string;
  label: string;
}

export interface AttendeeSection {
  Users: Attendee[];
  Devices: Attendee[];
}

export interface HelloSpokeConferenceDevice {
  id: string;
  name: string[];
  mac_address: string;
  owner_id: string;
  enabled: boolean;
  device_type: string;
}

// Per dashboard v1-1.pdf section 3.2.2, Kazoo API contacts will be listed in the
// contacts list. These contacts are searchable in the Caller Info tile (section 3.2.5)
// Interface derived from:
// https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
declare interface KazooContact {
  external_number: string;
  internal_number: string;
  name: string;
}

// **THIS IS A SPECULATIVE INTERFACE**
// I was unable to find concrete documentaction for what fields would be included
// in the Hellospoke database for contacts, so I will update the interface
// accordingly once known. These fields are listed as example fields for the
// contact database in dashboard v1-1.pdf section 5.5.
export interface HellospokeContact {
  first_name: string;
  last_name: string;
  main_number: string;
  mobile_number?: MobileNumber;
  email: string;
  allow_texts: boolean;
  address?: string;

  // Not explicitly listed in 5.5, but in 3.2.5 it is stated that the tiles
  // in the light gray area should be updated accordingly, so I would imagine
  // these fields are associated with a Hellospoke contact
  notes?: string[];
  documents?: any[];
  call_history?: any[];
  text_messages?: any[];
}

// Detailed in dashboard v1-1.pdf section 5.5
declare interface MobileNumber {
  phone_number: string;
  text_enabled: boolean;
}

// From section 3.4
export interface HellospokeUser {
  user_id: number;
  first_name: string;
  last_name: string;
  presence_id: string;
  priv_level: "user" | "manager" | "admin" | "voitress-admin";
  assigned_managers: string[];
  text_permissions: TextPermission[];
}

declare interface AdminState {
  selectedAccount: string;
  company_name: string;
  admin_loader: boolean;
  notification_load: boolean;
  notification_status: number;
}

export const store = new Vuex.Store({
  state: {
    conference: {},
    account: {
      jwt: window.localStorage.getItem("id_token") || "",

      privilege_level: "user",

      // Described in 3.2.1 and 5.7, would normally be coming from DB view

      // For the time being, yes we need this here. These are the numbers
      // that the HS people enabled for testing. Eventually they of course
      // need to be gotten from an API.
      text_permissions: [],
      admin_hellospoke_accounts: [],
      documents: [],
      settings: {
        enable_call_forward: false,
        vm_to_email_enabled: false,
        phone_number: "",
        email: "",
        ring_voip_phone: false,
        keep_caller_id: false,
        first_name: "",
        imageUrl: "",
      },
      devices: [],
      voicemails: [],
      vm_id: "",
      my_call_history: {
        bookmarks: {},
        cdrs: [],
      },
      my_call_history_load_more: false,

      my_call_history_loader: true,
      call_id: null,
      encrypted_creds: "",
      account_name: "",
      account_id: window.localStorage.getItem("account_id") || "",
      logout_status: false,
    },
    reports: {
      showReplaceModal: false,
      total: "0",
      searchtext: "",
      searchtext_clear: false,
      voicedata_load: false,
      monthyearindex: 0,
      monthyear: [],
      showDeleteModal: false,
      replaceFilename: "",
      callreport_Slide: false, //true,
      currentFiltersHaveRun: false,
      filters: {
        inboundChecked: true, //false,
        inboundChecked_schedule: false,
        outboundChecked: true, //false,
        outboundChecked_Schedule: false,
        startDate: new Date(), //null,
        endDate: new Date(), //null,
        answeredYes: true, // false,
        answeredYes_schedule: false,
        answeredNo: true, // false,
        answeredNo_schedule: false,
        extensionsList: [],
        extensionsList_schedul: [],
        extensionsList_selectAll: false,
        extensionsList_selectAllSchedul: false,
        startDate_Schedul: null,
        endDate_Schedul: null,

        assignedUserIds: [],
        timezone: {
          abbrev: "ET",
          tz: "America/Kentucky/Louisville",
        },
      },
      callReports: [],
      callReportsHistory: [],
      voicemail_records: [],
      record_data: {
        timestamp: "",
        media_url: "",
      },
      showLoadMoreBar: false,
      showProgress: false,
      download_spin: false,

      loadingMore: false,
      bookmark: "",
      report_sort: {
        sortreport_status: false,
        sort_by: "",
        asc_desc: false,
      },

      scheduleForm: {
        filename: "",
        email: "",
        dailyEnabled: false,
        weeklyEnabled: false,
        enabledDay: "",
        monthlyEnabled: false,
        monthlyDelivery: "none",
        weeklyTime: new Date(Date.parse("1970-01-01 1:00 PM EDT")),
        dailyTime: new Date(Date.parse("1970-01-01 1:00 PM EDT")),
        monthlyTime: new Date(Date.parse("1970-01-01 1:00 PM EDT")),
        WeeklyDays_EnalbeList: [
          {
            day: "Sun",
            value: false,
          },
          {
            day: "Mon",
            value: false,
          },
          {
            day: "Tue",
            value: false,
          },
          {
            day: "Wed",
            value: false,
          },
          {
            day: "Thu",
            value: false,
          },
          {
            day: "Fri",
            value: false,
          },
          {
            day: "Sat",
            value: false,
          },
        ],
      },
      scheduledReports: [],
    },
    dashboard: {
      isIDLE: false,
      IsConferenceLoaded: false,
      ConferenceData: null,
      ConferenceUserList: [],
      User_dashbord: [],
      ConferecneParticipantList: [],
      Confrence_On: false,
      AttendeeSectionList: {},
      Devices: [],
      Channels: [],
      OnGoinCalls: [],
      ConferenceDeviceList: [],
      selectedContact: null,
      selectednotificationContact: null,
      from_textpanel_contact: false,
      selectedContact_menu: null,
      selectedContactOnCall: null,
      incomingCaller: null,
      contactsidebar_status: "personal",
      textmsgtab: "",
      oldsettaglist: [],
      selectedmsghistory: [],
      SharedContact_count: 0,
      SharedContact_List: [],
      PersonalContact_Count: 0,
      PersonalContact_List: [],
      PresenceContact_count: 0,
      FavoirteContact_Count: 0,
      FavoirteContact_List: [],
      companyContact_List: [],
      Contact_loader: false,
      Tag_status: false,
      handletagsidebar: false,
      Tab_Mang: "",
      Tab_Action: {},
      Managing_Tag: "",
      Tag_list: [],
      NewTags: [],
      contact_modalstatus: "",
      ismultipledelete: true,
      contact_handler: {},
      SharedContact_status: false,
      contacts: [],
      result_contacts: [],
      feedbackMessage: "",
      selected_contact: [],
      admin: {
        selectedAccount: "",
        company_name: "",
        admin_loader: false,
        notification_load: false,
        notification_status: 0,
      },
      text_history: [],
      textmessage_limit: 0,
      notes: [],
      note_status: false,
      isLoading_Note: false,
      call_history: {
        bookmarks: {},
        cdrs: [],
      },
      call_history_load_more: false,
      call_history_loader: false,

      show_quick_call_modal: false,
      show_conference_modal: false,
      number_to_call: "",
      notifications: [],
      notifiaction_ringtone: false,
      incommingmessagenotification: null,
      socket: null,
      notifications_socket: null,
      readnotifactionfrom_badge: false,
      readnotifactionfrom_notifModal: "",
      blackhole_socket: null,
      incoming_text: null,
      start_newtext: false,
      selectedfile: "",
      textpannel_contactinfo: "",
      notification_contactinfo: "",
      number_being_called: null,
      Onchange_textnumber: "",
      Onchange_textnumberstatus: false,
      foucuson_text: "",
      load_more_text: false,
      newcontact_status: false,
      newcontact_creat_Number: "",
      editcontact_status: false,
      contactdetail: false,
      contactstatusvm: false,
      notificationvmid: "",
      voice_notification: "",
      userfirstname: "",
      userlastname: "",
      logger_userid: "",
      logger_profile: "",
      contactlist_status: true,
      contact_info_loader: false,
      user_image_url: "",
      tagname: [], //'',
      userid: "",
      c: 0,
      t: "",
      timer_is_on: 0,
    },
  },
  mutations: {
    // tslint:disable-next-line:no-empty
    LOGIN_SENT: () => {},
    LOGIN_SUCCESS: (state, payload) => {
      window.localStorage.setItem("id_token", payload.data.token);
      state.account.jwt = payload.data.token;
      state.dashboard.blackhole_socket = null;
      state.dashboard.notifications_socket = null;
    },
    LOGOUT_SUCCESS: (state, payload) => {
      state.dashboard.notes = [];
      state.dashboard.selectedContact = null;
      state.dashboard.selectedContact_menu = null;
      window.localStorage.removeItem("id_token");
      state.account.jwt = null;
      window.localStorage.removeItem("account_id");
      state.account.account_id = null;
    },

    CONTACT_SIDEBARSTATSU: (state, payload) => {
      state.dashboard.contactsidebar_status = payload;
    },
    SET_TEXTMESSAGETAB: (state, payload) => {
      state.dashboard.textmsgtab = payload;
    },
    SET_OLDTAGLIST: (state, payload) => {
      state.dashboard.oldsettaglist = payload;
    },
    SELECTED_MSG_HISTORY: (state, payload) => {
      state.dashboard.selectedmsghistory = payload;
    },
    SHAREDCONTACT_COUNT: (state, payload) => {
      state.dashboard.SharedContact_count = payload;
    },
    SHAREDCONTACT_LIST: (state, payload) => {
      state.dashboard.SharedContact_List = payload;
    },
    PERSONALCONTACT_COUNT: (state, payload) => {
      state.dashboard.PersonalContact_Count = payload;
    },
    PERSONALCONTACT_LIST: (state, payload) => {
      state.dashboard.PersonalContact_List = payload;
    },

    PRESENCECONTACT_COUNT: (state, payload) => {
      state.dashboard.PresenceContact_count = payload;
    },
    FAVORITECONTACT_COUNT: (state, payload) => {
      state.dashboard.FavoirteContact_Count = payload;
    },

    FAVORITECONTACT_LIST: (state, payload) => {
      state.dashboard.FavoirteContact_List = payload;
    },
    COMPANYCONTACT_LIST: (state, payload) => {
      state.dashboard.companyContact_List = payload;
    },
    SET_CONTACT_LOADER: (state, payload) => {
      state.dashboard.Contact_loader = payload;
    },
    TAB_MANAG: (state, payload) => {
      state.dashboard.Tab_Mang = payload;
    },
    TAB_ACTION: (state, payload) => {
      state.dashboard.Tab_Action = payload;
    },
    SHARED_CONTACT_STATSUS: (state, payload) => {
      state.dashboard.SharedContact_status = payload;
    },

    // Managing_Tag:
    MANAGING_TAG: (state, payload) => {
      state.dashboard.Managing_Tag = payload;
    },
    TAG_LIST: (state, payload) => {
      state.dashboard.Tag_list = payload;
    },
    NEW_TAGIST: (state, payload) => {
      state.dashboard.NewTags = payload;
    },
    CONTACT_MODAL_STATSUS: (state, payload) => {
      state.dashboard.contact_modalstatus = payload;
    },
    SET_MULTIPLEDELETE: (state, payload) => {
      state.dashboard.ismultipledelete = payload;
    },

    contact_handler: (state, payload) => {
      state.dashboard.contact_handler = payload;
    },
    TAB_STATUS: (state, payload) => {
      state.dashboard.Tag_status = payload;
    },
    HANDLE_TAG_SIDEBAR: (state, payload) => {
      state.dashboard.handletagsidebar = payload;
    },
    LOGOUT_STATUS: (state, payload) => {
      state.account.logout_status = payload;
    },

    SET_JWT: (state, payload) => {
      state.account.jwt = payload;
    },
    // tslint:disable-next-line:no-empty
    LOGIN_FAIL: () => {
      store.commit("LOGOUT_SUCCESS");
    },
    INBOUND_CALL_CHANGE: (state, payload) => {
      state.reports.filters.inboundChecked = payload.newVal;
    },

    INBOUND_CALL_CHANGE_SCHEDULE: (state, payload) => {
      state.reports.filters.inboundChecked_schedule = payload.newVal;
    },

    OUTBOUND_CALL_CHANGE: (state, payload) => {
      state.reports.filters.outboundChecked = payload.newVal;
    },
    OUTBOUND_CALL_CHANGE_SCHEDULE: (state, payload) => {
      state.reports.filters.outboundChecked_Schedule = payload.newVal;
    },

    LOAD_MORE_BAR_VISIBLE: (state, payload) => {
      state.reports.showLoadMoreBar = payload.isVisible; //download_spin
    },
    SHOW_DOWNLOAD_SPIN: (state, payload) => {
      state.reports.download_spin = payload; //download_spin
    },
    SHOW_PROGRESS_BAR_VISIBLE: (state, payload) => {
      state.reports.showProgress = payload.isVisible;
    },
    CALL_HISTORY_LOAD_MORE_VISIBLE: (state, payload) => {
      state.dashboard.call_history_load_more = payload;
    },

    CALL_HISTORY_LOADER: (state, payload) => {
      state.dashboard.call_history_loader = payload;
    },

    MY_CALL_HISTORY_LOAD_MORE_VISIBLE: (state, payload) => {
      state.account.my_call_history_load_more = payload;
    },
    MY_CALL_HISTORY_LOADER_VISIBLE: (state, payload) => {
      state.account.my_call_history_loader = payload;
    },
    SearchText_update: (state, payload) => {
      state.reports.searchtext = payload;
    },
    SearchText_CLEAR: (state, payload) => {
      state.reports.searchtext_clear = payload;
    },
    VOICEMAIL_STATUS: (state, payload) => {
      state.reports.voicedata_load = payload;
    },
    // tslint:disable-next-line:no-empty
    CALL_REPORTS_SENT: (state) => {},
    UPDATE_MONTH_LIST: (state, payload) => {
      const my = {};

      state.reports.monthyear = payload.monthlist;
    },
    UPDATE_CALL_REPORTS: (state, payload) => {
      state.reports.total = payload.total;
      state.reports.monthyearindex = payload.monthindex;
      let cleardata = payload.hasOwnProperty("clear") ? payload.clear : false;
      if (cleardata) {
        state.reports.callReports = [];
      } else {
        state.reports.callReports.push(...payload.cdrs);
      }
    },

    UPDATE_CALL_REPORTS_DOWNLOADS: (state, payload) => {
      const currentCDRs = payload.cdrs;
      state.reports.callReportsHistory = currentCDRs;
    },
    LOADING_MORE: (state, payload) => {
      state.reports.loadingMore = payload.loadingMore;
    },

    CLEAR_CALLREPORTS: (state, payload) => {
      var status = false;
      state.reports.callreport_Slide = status;
      state.reports.filters.inboundChecked = status;
      state.reports.filters.inboundChecked_schedule = status;
      state.reports.filters.outboundChecked = status;
      state.reports.filters.outboundChecked_Schedule = status;

      state.reports.filters.answeredNo = status;
      state.reports.filters.answeredNo_schedule = status;
      state.reports.filters.answeredYes = status;
      state.reports.filters.answeredYes_schedule = status;
      (state.reports.filters.startDate = null), //'';
        (state.reports.filters.endDate = null), //'';
        (state.reports.scheduleForm.monthlyDelivery = "none");
      state.reports.filters.startDate_Schedul = "";
      state.reports.filters.endDate_Schedul = "";

      state.reports.filters.extensionsList_selectAll = status;
      state.reports.filters.extensionsList_selectAllSchedul = status;
      state.reports.filters.extensionsList = [];
      state.reports.filters.extensionsList_schedul = [];

      state.reports.scheduleForm.filename = "";
      state.reports.scheduleForm.email = "";

      state.reports.scheduleForm.dailyEnabled = status;
      state.reports.scheduleForm.weeklyEnabled = status;
      state.reports.scheduleForm.monthlyEnabled = status;
    },
    ANSWERED_YES_CHANGE: (state, payload) => {
      state.reports.filters.answeredYes = payload.newVal;
    },
    ANSWERED_YES_CHANGE_SCHEDULE: (state, payload) => {
      state.reports.filters.answeredYes_schedule = payload.newVal;
    },

    ANSWERED_NO_CHANGE: (state, payload) => {
      state.reports.filters.answeredNo = payload.newVal;
    },
    ANSWERED_NO_CHANGE_SCHEDULE: (state, payload) => {
      state.reports.filters.answeredNo_schedule = payload.newVal;
    },
    UPDATE_ASSIGNED_USER_IDS: (state, payload) => {
      state.reports.filters.assignedUserIds = payload.assignedUserIds;
    },
    UPDATE_EXTENSIONS_LIST: (state, payload) => {
      state.reports.filters.extensionsList = payload.extensions;
    },
    UPDATE_EXTENSIONS_LIST_SCHEDULE: (state, payload) => {
      state.reports.filters.extensionsList_schedul = payload.extensions; //push(...payload.extensions) ;
    },
    UPDATE_EXTENSIONS_LIST_SELECTALL: (state, payload) => {
      state.reports.filters.extensionsList_selectAll = payload; //push(...payload.extensions) ;
    },
    UPDATE_EXTENSIONS_LIST_SELECTALLSCHEDULE: (state, payload) => {
      state.reports.filters.extensionsList_selectAllSchedul = payload; //push(...payload.extensions) ;
    },
    SET_START_DATE_SCHEDULE: (state, payload) => {
      state.reports.filters.startDate_Schedul = payload;
    },
    SET_END_DATE_SCHEDULE: (state, payload) => {
      state.reports.filters.endDate_Schedul = payload;
    },

    SET_TIMEZONE: (state, payload) => {
      state.reports.filters.timezone = payload.timezone;
    },
    SET_START_DATE: (state, payload) => {
      state.reports.filters.startDate = payload;
    },
    SET_END_DATE: (state, payload) => {
      state.reports.filters.endDate = payload;
    },

    SET_SCHEDULE_DAILY: (state, payload) => {
      state.reports.scheduleForm.dailyEnabled = payload.daily;
    },
    SET_SCHEDULE_WEEKLY: (state, payload) => {
      state.reports.scheduleForm.weeklyEnabled = payload.weekly;
    },

    SET_SCHEDULE_MONTHLY: (state, payload) => {
      state.reports.scheduleForm.monthlyEnabled = payload.monthly;
    },
    SET_SCHEDULE_DAY: (state, payload) => {
      state.reports.scheduleForm.enabledDay = payload;
    },
    SET_MONTHLY_DELIVERY: (state, { frequency }) => {
      state.reports.scheduleForm.monthlyDelivery = frequency;
    },
    SET_FILENAME: (state, filename) => {
      state.reports.scheduleForm.filename = filename;
    },
    SET_EMAIL: (state, email) => {
      state.reports.scheduleForm.email = email;
    },
    SET_CURRENT_FILTERS_RUN: (state, { filtersRun }) => {
      state.reports.currentFiltersHaveRun = filtersRun;
    },
    CALLREPORT_SLIDER: (state, payload) => {
      state.reports.callreport_Slide = payload;
    },
    SET_DAILY_TIME: (state, { newTime }) => {
      state.reports.scheduleForm.dailyTime = newTime;
    },
    SET_WEEKLY_TIME: (state, { newTime }) => {
      state.reports.scheduleForm.weeklyTime = newTime;
    },
    SET_MONTHLY_TIME: (state, { newTime }) => {
      state.reports.scheduleForm.monthlyTime = newTime;
    },

    SET_USER_FIRST_NAME: (state, payload) => {
      state.dashboard.userfirstname = payload;
    },
    SET_USER_LAST_NAME: (state, payload) => {
      state.dashboard.userlastname = payload;
    },

    SET_LOGGER_USER_ID: (state, payload) => {
      state.dashboard.logger_userid = payload;
    },
    SET_LOGGER_PROFILE: (state, payload) => {
      state.dashboard.logger_profile = payload;
    },

    SET_USER_IMAGE: (state, payload) => {
      state.dashboard.user_image_url = payload;
    },
    SET_TAG_NAME: (state, payload) => {
      state.dashboard.tagname = payload;
    },

    SET_SETTINGS: (state, payload) => {
      const data = payload.data;
      if (
        data.call_forward &&
        typeof data.call_forward.enabled !== "undefined"
      ) {
        state.account.settings.enable_call_forward = data.call_forward.enabled;
      } else {
        state.account.settings.enable_call_forward = false;
      }
      if (data.call_forward && data.call_forward.enabled) {
        if (typeof data.call_forward.number !== "undefined") {
          state.account.settings.phone_number = data.call_forward.number;
        }
        if (typeof data.call_forward.substitute !== "undefined") {
          state.account.settings.ring_voip_phone = data.call_forward.substitute;
        }
        if (typeof data.call_forward.keep_caller_id !== "undefined") {
          state.account.settings.keep_caller_id =
            data.call_forward.keep_caller_id;
        }
      } else {
        state.account.settings.phone_number = "";
        state.account.settings.ring_voip_phone = false;
        state.account.settings.keep_caller_id = false;
      }
      if (typeof data.vm_to_email_enabled !== "undefined") {
        state.account.settings.vm_to_email_enabled = data.vm_to_email_enabled;
      }
      if (
        state.account.settings.vm_to_email_enabled &&
        typeof data.email !== "undefined"
      ) {
        state.account.settings.email = data.email;
      } else {
        state.account.settings.email = "";
      }
      //this will trigger settings window changes
      var email = state.account.settings.email;
      state.account.settings.email = "x";
      state.account.settings.email = email;
      state.account.settings.first_name = data.first_name;
      state.account.settings.imageUrl = data.imageUrl;
    },
    SET_PRIVILEGE_LEVEL: (state, payload) => {
      state.account.privilege_level = payload;
    },
    SET_DEVICES: (state, payload) => {
      state.account.devices = payload;
    },
    SET_VOICEMAILS: (state, payload) => {
      state.account.voicemails = payload;
      var voicecalls = [];
      state.reports.voicemail_records = [];
      payload.forEach((element) => {
        getVoicemailContact(element.caller_id_number).then((callername) => {
          var newobj = {
            call_direction: "inbound",
            call_recording: element.media_id,
            call_recording_medias: [],
            dialed_number: element.to,
            duration: (element.length / 1000).toFixed(0),
            from_name: callername, //element.caller_id_name,
            from_number: element.caller_id_number,
            id: "201909-161797_rel77ZmExMTY5YzAwNDJjYzcyYmYzYzY1OWU5OThiYWE4MmE",
            timestamp: element.timestamp,
            to_name: null,
            to_number: element.to,
            type: "VM",
            media_id: element.media_id,
          };
          voicecalls.push(newobj);
          //state.dashboard.call_history.cdrs.push (...voicecalls );
          //state.reports.voicemail_records=voicecalls;
          state.reports.voicemail_records.push(...voicecalls);
          state.dashboard.call_history.cdrs =
            state.dashboard.call_history.cdrs.concat(voicecalls);
          voicecalls = [];
        });
      });
    },
    SET_RECORDS_DATA: (state, payload) => {
      state.reports.record_data = {
        timestamp: payload.timstamp,
        media_url: payload.mediaUrl,
      };
    },

    SET_VOICEMAILS_REPO: (state, payload) => {
      state.account.voicemails = payload;
      var voicecalls = [];

      payload.forEach((element) => {
        getVoicemailContact(element.caller_id_number).then((callername) => {
          var newobj = {
            call_direction: "inbound",
            call_recording: element.media_id,
            call_recording_medias: [],
            dialed_number: element.to,
            duration: (element.length / 1000).toFixed(0),
            from_name: callername, //element.caller_id_name,
            from_number: element.caller_id_number,
            id: "201909-161797_rel77ZmExMTY5YzAwNDJjYzcyYmYzYzY1OWU5OThiYWE4MmE",
            timestamp: element.timestamp,
            to_name: null,
            to_number: element.to,
            type: "VM",
            media_id: element.media_id,
          };
          voicecalls.push(newobj);

          var s_date = new Date(
            moment(state.reports.filters.startDate).format("YYYY-MM-DD")
          );

          var E_date = new Date(
            moment(state.reports.filters.endDate).format("YYYY-MM-DD")
          );

          voicecalls.forEach((voice, index) => {
            var voice_date = new Date(
              moment((voice.timestamp - 62167219200) * 1000).format(
                "YYYY-MM-DD"
              )
            );

            var phoneNumber = voicecalls[index].dialed_number.split("@");
            voicecalls[index].dialed_number = phoneNumber[0];

            if (voice_date >= s_date && voice_date <= E_date) {
              state.reports.callReports.push(...voicecalls); //for callreport
              //state.reports.callReportsHistory.push(...voicecalls);
            }
          });
          //state.reports.callReports.push (...voicecalls );
          voicecalls = [];
        });
      });
    },
    SET_VOICEMAILS_REPORT_DOWNLOAD: (state, payload) => {
      state.account.voicemails = payload;
      var voicecalls = [];
      payload.forEach((element) => {
        getVoicemailContact(element.caller_id_number).then((callername) => {
          var newobj = {
            call_direction: "inbound",
            call_recording: element.media_id,
            call_recording_medias: [],
            dialed_number: element.to,
            duration: (element.length / 1000).toFixed(0),
            from_name: callername, //element.caller_id_name,
            from_number: element.caller_id_number,
            id: "201909-161797_rel77ZmExMTY5YzAwNDJjYzcyYmYzYzY1OWU5OThiYWE4MmE",
            timestamp: element.timestamp,
            to_name: null,
            to_number: element.to,
            type: "VM",
            media_id: element.media_id,
          };
          voicecalls.push(newobj);

          var s_date = new Date(
            moment(state.reports.filters.startDate).format("YYYY-MM-DD")
          );

          var E_date = new Date(
            moment(state.reports.filters.endDate).format("YYYY-MM-DD")
          );

          voicecalls.forEach((voice, index) => {
            var voice_date = new Date(
              moment((voice.timestamp - 62167219200) * 1000).format(
                "YYYY-MM-DD"
              )
            );
            var phoneNumber = voicecalls[index].dialed_number.split("@");
            voicecalls[index].dialed_number = phoneNumber[0];
            if (voice_date >= s_date && voice_date <= E_date) {
              state.reports.callReportsHistory.push(...voicecalls);
            }
          });

          voicecalls = [];
        });
      });
    },
    REMOVE_VOICEMAIL: (state, payload) => {
      state.account.voicemails = state.account.voicemails.filter(
        (e) => (e as any).media_id !== payload
      );
    },
    SET_VM_ID: (state, payload) => {
      state.account.vm_id = payload;
    },
    SET_ACCOUNT_ID: (state, payload) => {
      window.localStorage.setItem("account_id", payload);
      state.account.account_id = payload;
    },
    // Caller Info Tile mutations
    CHANGE_SELECTED_CONTACT: (state, payload) => {
      state.dashboard.selectedContactOnCall = state.dashboard.selectedContact;
      state.dashboard.selectedContact = payload;
    },
    CHANGE_NOTIFICATION_CONTACT: (state, payload) => {
      state.dashboard.selectednotificationContact = payload;
    },
    //For edit contact modal show from textpanel
    SET_TEXTPANEL_CONTACT_SELECTION: (state, payload) => {
      state.dashboard.from_textpanel_contact = payload;
    },
    //side bar contact menu
    SELECTED_CONTACT_MENU: (state, payload) => {
      state.dashboard.selectedContact_menu = payload;
    },

    SET_NOTES: (state, payload) => {
      state.dashboard.notes = payload;
    },
    SET_NOTES_STATUS: (state, payload) => {
      state.dashboard.note_status = payload;
    },

    SET_CONFERENCE: (state, payload) => {
      state.dashboard.ConferenceData = payload;
    },
    SET_CONFERENCE_STATE: (state, payload) => {
      state.dashboard.IsConferenceLoaded = payload;
    },
    SET_CHANNEL_DEVICES: (state, payload) => {
      state.dashboard.Devices = payload;
    },
    SET_CONFERENCE_DEVICES: (state, payload) => {
      state.dashboard.AttendeeSectionList = {
        ...state.dashboard.AttendeeSectionList,
        ...payload,
      };
    },
    SET_CONFERENCE_USERS: (state, payload) => {
      state.dashboard.ConferenceUserList = payload.sort((a, b) =>
        a.first_name > b.first_name ? 1 : b.first_name > a.first_name ? -1 : 0
      );
    },
    SET_DASHBOARD_USERS: (state, payload) => {
      state.dashboard.User_dashbord = payload; //payload.sort((a,b) => (a.first_name > b.first_name) ? 1 : ((b.first_name > a.first_name) ? -1 : 0));
    },
    SET_IDLESYSYTM: (state, payload) => {
      state.dashboard.isIDLE = payload;
    },

    ADD_CONFERENCE_PARTICIPANT_LIST: (state, payload) => {
      const member = state.dashboard.ConferecneParticipantList.find(
        (e) => (e as any).member_id === payload.member_id
      );

      if (!member) state.dashboard.ConferecneParticipantList.push(payload);
      state.dashboard.Confrence_On = true;
      //  state.dashboard.ConferecneParticipantList.push( payload);
      // console.log(state.dashboard.ConferecneParticipantList);
    },
    CLEAR_CONFERENCE_PARTICIPANT_LIST: (state) => {
      state.dashboard.AttendeeSectionList = [];
    },
    SET_CONFERENCE_ATTENDEE: (state, payload) => {
      state.dashboard.AttendeeSectionList = payload;
    },

    SET_ONGOING_CALLS: (state, payload) => {
      state.dashboard.OnGoinCalls.push(payload);
    },

    SET_CHANNELS_ATTENDEE: (state, payload) => {
      /*  var groupBy = function(xs, key) {
            return xs.reduce(function(rv, x) {
              (rv[x[key]] = rv[x[key]] || []).push(x);
              return rv;
            }, {});
          };*/
      //    var groupedresult=  groupBy(payload, "interaction_id");

      const filterchannels = payload.filter(
        (channel) => channel.authorizing_id != undefined
      );
      state.dashboard.Channels = filterchannels;
    },
    LOADING_NOTES_STATUS: (state, payload) => {
      state.dashboard.isLoading_Note = payload;
    },

    UPDATE_CONTACT_INFORMATION: (state, payload) => {
      const index = state.dashboard.contacts.findIndex((e) => {
        return (e as any)._id === payload._id;
      });
      (state as any).dashboard.contacts[index] = payload;
      state.dashboard.selectedContact = payload;
    },

    CREATE_CONTACT: (state, payload) => {
      // will implement once Kazoo API contacts are functioning with the Caller Info Component
    },

    MERGE_contact: (state, payload) => {
      // state.dashboard.load_more_text = payload.length>=25;
      const history = payload.concat(state.dashboard.contacts);
      state.dashboard.contacts = history;
    },
    SET_CONTACTS: (state, payload) => {
      // Per the conversation on teamwork this is filtering out all public contacts
      // who have:
      // 1. The same mobile number as a private contact
      // 2. The main number(s) of the public contact are a subset of that same private contact
      let contacts = [];
      const publicContacts = payload.filter(
        (contact) => contact.private === false
      );
      const privateContacts = payload.filter(
        (contact) => contact.private === true
      );

      for (const publicContact of publicContacts) {
        let addContact = true;
        for (const privateContact of privateContacts) {
          if (
            publicContact.numbers.mobile.number ===
            privateContact.numbers.mobile.number
          ) {
            let matches = 0;
            for (const num of publicContact.numbers.main) {
              if (privateContact.numbers.main.includes(num)) {
                matches++;
              }
            }
            if (matches === publicContact.numbers.main.length) {
              addContact = false;
              break;
            }
          }
        }
        if (addContact) {
          contacts.push(publicContact as never);
        }
      }
      contacts = contacts.concat(privateContacts);
      if (state.dashboard.selectedContact) {
        const _contact = contacts.find(
          (e) => (e as any)._id === (state.dashboard.selectedContact as any)._id
        );
        // state.dashboard.selectedContact.notes=_contact.notes;
      }
      for (const contc of payload) {
        if (contc.numbers && contc.numbers.main) {
          contc.numbers.main =
            contc.numbers.main.toString().indexOf("+1") == -1
              ? "+1" + contc.numbers.main
              : contc.numbers.main;
        }
        if (contc.numbers.mobile && contc.numbers.mobile.number) {
          contc.numbers.mobile.number =
            contc.numbers.mobile.number.toString().indexOf("+1") == -1
              ? "+1" + contc.numbers.mobile.number
              : contc.numbers.mobile.number;
        }
      }
      state.dashboard.contacts = payload;
    },
    FEEDBACKMESSAGE_CONTACT: (state, payload) => {
      state.dashboard.feedbackMessage = payload;
    },
    SET_SELECTED_CONTACTS: (state, payload) => {
      state.dashboard.selected_contact = payload;
    },

    ADD_CONTACTS: (state, payload) => {
      state.dashboard.contacts = state.dashboard.contacts.concat(payload);
    },

    NEW_CONTACT_CREATE: (state, payload) => {
      state.dashboard.newcontact_status = payload;
    },

    NEW_CONTACT_CREATE_WITHNUMBER: (state, payload) => {
      state.dashboard.newcontact_creat_Number = payload;
    },

    EDIT_CONTACT_UPDATE: (state, payload) => {
      state.dashboard.editcontact_status = payload;
    },
    SHOW_CONTACT_DETAIL: (state, payload) => {
      state.dashboard.contactdetail = payload; //contactlist_status
    },
    SET_CONTACT_STATUS_VM: (state, payload) => {
      state.dashboard.contactstatusvm = payload; //contactlist_status
    },

    SET_NOTIFICATION_VM_ID: (state, payload) => {
      state.dashboard.notificationvmid = payload; //contactlist_status
    },
    SET_NOTIFICATION_VOICE: (state, payload) => {
      state.dashboard.voice_notification = payload; //contactlist_status
    },

    SHOW_CONTACT_LIST: (state, payload) => {
      state.dashboard.contactlist_status = payload; // contact_info_loader
    },
    SHOW_CONTACT_INFOLOADER: (state, payload) => {
      state.dashboard.contact_info_loader = payload; //
    },
    SET_TEXT_HISTORY: (state, payload) => {
      state.dashboard.load_more_text = payload.length >= 25;
      const uniqueAddresses = Array.from(
        new Set(payload.map((a) => a.messageId))
      ).map((messageId) => {
        return payload.find((a) => a.messageId === messageId);
      });
      state.dashboard.text_history = uniqueAddresses;
    },

    SET_TEXT_LIMIT: (state, payload) => {
      state.dashboard.textmessage_limit = payload;
    },
    APPEND_NEW_TEXTS: (state, payload) => {
      state.dashboard.text_history =
        state.dashboard.text_history.concat(payload);
    },
    MERGE_TEXTS: (state, payload) => {
      state.dashboard.load_more_text = payload.length >= 25;
      const history = payload.concat(state.dashboard.text_history);
      history.sort((a, b) => {
        const d1 = new Date(a.time);
        const d2 = new Date(b.time);
        return d1 < d2 ? -1 : 1;
      });
      state.dashboard.text_history = history;
    },
    SET_ADMIN_HELLOSPOKE_ACCOUNTS: (state, payload) => {
      state.account.admin_hellospoke_accounts = payload;
    },

    DOCUMENT_ADDED: (state, payload) => {
      state.account.documents.push(payload as never);
    },

    DOCUMENT_DELETED: (state, payload) => {
      // Dummy functionality
      const len = state.account.documents.length;
      for (let i = 0; i < len; i++) {
        if ((state.account.documents[i] as any).id === payload.id) {
          state.account.documents.splice(i, 1);
          i = len;
        }
      }
    },
    SET_CALL_HISTORY: (state, payload) => {
      state.dashboard.call_history.bookmarks = payload.bookmarks;
      state.dashboard.call_history.cdrs = payload.cdrs; // state.dashboard.call_history.cdrs.concat(payload.cdrs);
    },
    SET_CALL_HISTORY_LOADMORE: (state, payload) => {
      state.dashboard.call_history.bookmarks = payload.bookmarks;
      state.dashboard.call_history.cdrs =
        state.dashboard.call_history.cdrs.concat(payload.cdrs);
    },

    SET_MY_CALL_HISTORY: (state, payload) => {
      (state.account.my_call_history as any).bookmarks = payload.bookmarks;
      (state.account.my_call_history as any).cdrs = payload.cdrs;
    },
    APPEND_MY_CALL_HISTORY: (state, payload) => {
      (state.account.my_call_history as any).bookmarks = payload.bookmarks;
      // tslint:disable-next-line:max-line-length
      (state.account.my_call_history as any).cdrs = (
        state.account.my_call_history as any
      ).cdrs.concat(payload.cdrs);
    },
    SET_SELECTED_ADMIN_ID: (state, { selectedAccount }) => {
      state.dashboard.admin.selectedAccount = selectedAccount;
    },
    SET_SELECTED_ADMIN_NAME: (state, payload) => {
      state.dashboard.admin.company_name = payload;
    },
    SET_ADMIN_LOADER: (state, payload) => {
      state.dashboard.admin.admin_loader = payload;
    },
    SET_NOTIFICATION_LOAD: (state, payload) => {
      state.dashboard.admin.notification_load = payload;
    },
    SET_NOTIFICATION_STATUS: (state) => {
      var nts = state.dashboard.notifications;
      state.dashboard.admin.notification_status = nts.filter(
        (e) => e.read == false
      ).length;
    },
    SET_NOTIFICATION_RINGTONE: (state, payalod) => {
      state.dashboard.notifiaction_ringtone = payalod;
    },
    SET_NOTIFICATION_BADGE: (state, payalod) => {
      state.dashboard.readnotifactionfrom_badge = payalod;
    },
    SET_NOTIFICATION_NOTIFICATIONMODAL: (state, payalod) => {
      state.dashboard.readnotifactionfrom_notifModal = payalod;
    },

    DELETE_SCHEDULED_REPORT: (state, { id }) => {
      state.reports.scheduledReports = state.reports.scheduledReports.filter(
        (e) => (e as any)._id !== id
      );
    },
    SET_BOOKMARK: (state, payload) => {
      state.reports.bookmark = payload.bookmark;
    },
    SET_CALLREPORT_SORT: (state, payload) => {
      state.reports.report_sort = {
        sortreport_status: payload.reporsort_Statu,
        sort_by: payload.sortBy,
        asc_desc: payload.ststus,
      };
    },
    REPLACE_MODAL_HIDE: (state, payload) => {
      state.reports.showReplaceModal = false;
    },
    SHOW_DELETE_MODAL: (state, payalod) => {
      state.reports.showDeleteModal = true;
    },
    DELETE_MODAL_HIDE: (state, paylod) => {
      state.reports.showDeleteModal = false;
    },
    LOAD_REPORT: (state, payload) => {
      const { report, filters } = payload;
      //state.reports.filters.inboundChecked = ['both', 'inbound'].indexOf(filters.call_direction) >= 0;
      state.reports.filters.inboundChecked_schedule =
        ["both", "inbound"].indexOf(filters.call_direction) >= 0;
      // state.reports.filters.outboundChecked = ['both', 'outbound'].indexOf(filters.call_direction) >= 0;
      state.reports.filters.outboundChecked_Schedule =
        ["both", "outbound"].indexOf(filters.call_direction) >= 0;
      // state.reports.filters.answeredYes = ['both', 'true'].indexOf(filters.answered) >= 0;
      state.reports.filters.answeredYes_schedule =
        ["both", "true"].indexOf(filters.answered) >= 0;
      //state.reports.filters.answeredNo = ['both', 'false'].indexOf(filters.answered) >= 0;
      state.reports.filters.answeredNo_schedule =
        ["both", "false"].indexOf(filters.answered) >= 0;
      state.reports.scheduleForm.email = report.email_address;
      state.reports.scheduleForm.filename = report.filename;
      state.reports.scheduleForm.dailyEnabled =
        report.frequency.rate === "daily";
      state.reports.scheduleForm.monthlyEnabled =
        report.frequency.rate === "monthly";
      state.reports.scheduleForm.weeklyEnabled =
        report.frequency.rate === "weekly";

      state.reports.filters.startDate_Schedul = report.schedule_startDate;
      state.reports.filters.endDate_Schedul = report.schedule_endDate;
      var frequdate = new Date();
      frequdate.setHours(report.frequency.hour);
      if (state.reports.scheduleForm.dailyEnabled)
        state.reports.scheduleForm.dailyTime = frequdate;
      else state.reports.scheduleForm.dailyTime = null;
      if (state.reports.scheduleForm.weeklyEnabled) {
        state.reports.scheduleForm.weeklyTime = frequdate;

        state.reports.scheduleForm.WeeklyDays_EnalbeList.forEach(function (e1) {
          e1.value = false;
        });
        state.reports.scheduleForm.WeeklyDays_EnalbeList.forEach(function (e1) {
          report.frequency.day_of_week.forEach(function (e2) {
            if (e1.day == e2) {
              e1.value = true;
            }
          });
        });
        switch (report.frequency.day_of_week[0]) {
          case "sun":
            state.reports.scheduleForm.enabledDay = "sunday";
            break;
          case "mon":
            state.reports.scheduleForm.enabledDay = "monday";
            break;
          case "tues":
            state.reports.scheduleForm.enabledDay = "tuesday";
            break;
          case "wed":
            state.reports.scheduleForm.enabledDay = "wednesday";
            break;
          case "thurs":
            state.reports.scheduleForm.enabledDay = "thursday";
            break;
          case "fri":
            state.reports.scheduleForm.enabledDay = "friday";
            break;
          case "sat":
            state.reports.scheduleForm.enabledDay = "saturday";
            break;
          default:
            state.reports.scheduleForm.enabledDay = "";
        }
      } else state.reports.scheduleForm.weeklyTime = null;
      if (state.reports.scheduleForm.monthlyEnabled) {
        state.reports.scheduleForm.monthlyTime = frequdate;
        switch (report.frequency.day_of_month) {
          case 1:
            state.reports.scheduleForm.monthlyDelivery = "first";
            break;
          case 15:
            state.reports.scheduleForm.monthlyDelivery = "fifteenth";
            break;
          case -1:
            state.reports.scheduleForm.monthlyDelivery = "last";
            break;
          default:
            state.reports.scheduleForm.monthlyDelivery = "none";
            break;
        }
      } else {
        state.reports.scheduleForm.monthlyTime = null;
        state.reports.scheduleForm.monthlyDelivery = "none";
      }
    },
    SET_TEXT_PERMISSIONS: (state, payload) => {
      state.account.text_permissions = payload;
    },

    INCOMING_CALLER: (state, payload) => {
      state.dashboard.selectedContactOnCall = state.dashboard.selectedContact;
      state.dashboard.selectedContact = null;
      state.dashboard.incomingCaller = payload;
    },
    On_Call_SelectedContact: (state, payload) => {
      state.dashboard.selectedContactOnCall = payload;
    },

    HANGUP: (state, payload) => {
      store.commit(
        "CHANGE_SELECTED_CONTACT",
        state.dashboard.selectedContactOnCall
      );
      state.dashboard.selectedContactOnCall = null;
      state.dashboard.incomingCaller = null;
    },
    End_Call: (state, paylload) => {
      store.commit("UNSET_CALL_ID");
      store.commit("SHOW_CONTACT_DETAIL", paylload != null);
      store.commit("SHOW_CONTACT_LIST", paylload == null);
      store.commit("SET_NOTES_STATUS", false);

      store.commit("HANGUP");
    },
    QUICK_CALL: (state, payload) => {
      state.dashboard.number_to_call = payload;
      state.dashboard.show_quick_call_modal = true;
    },
    SHOW_CONFERENCEMODEL: (state, payload) => {
      state.dashboard.show_conference_modal = true;
    },
    HIDE_CONFERENCEMODEL: (state, payload) => {
      state.dashboard.show_conference_modal = false;
    },

    CLOSE_QUICK_CALL: (state, payload) => {
      state.dashboard.number_to_call = "";
      state.dashboard.show_quick_call_modal = false;
    },
    SET_CALL_ID: (state, payload) => {
      state.account.call_id = payload;
    },
    UNSET_CALL_ID: (state, payload) => {
      state.account.call_id = null;
    },
    CLEAR_NOTIFICATIONS: (state, payload) => {
      state.dashboard.notifications = [];
    },
    NEW_NOTIFICATION: (state, payload) => {
      var nt = state.dashboard.notifications.find(function (element) {
        return element.id === payload.id;
      });
      if (!nt) {
        state.dashboard.incommingmessagenotification = payload;
        state.dashboard.notifications.unshift(payload as never);
      }
    },
    DELETE_NOTIFICATION: (state, payload) => {
      var nt = state.dashboard.notifications.filter(
        (e) =>
          (e as any).id == payload.notificationId ||
          (e as any).number == payload.number
      );

      nt.forEach((element) => {
        element.read = true;
      });
    },
    NEW_INCOMING_TEXT: (state, payload) => {
      if (payload.media && payload.direction === "in") {
        payload.media = payload.media
          .filter((m) => m.indexOf(".smil") < 0)
          .filter((m) => m.indexOf(".txt") < 0);
        payload.media = payload.media.map((file) => {
          const fileParts = file.split("/media/");
          fileParts.shift();
          // tslint:disable-next-line:max-line-length
          return `${AppSettings.AWS_MMS_BUCKET}${state.account.account_id}/${fileParts[0]}`;
        });
      }

      if (
        !state.dashboard.incoming_text ||
        state.dashboard.incoming_text._id != payload._id
      )
        state.dashboard.incoming_text = payload;
    },

    SET_START_NEWTEXT: (state, payload) => {
      state.dashboard.start_newtext = payload;
    },
    SET_SELECTED_FILE: (state, payload) => {
      state.dashboard.selectedfile = payload;
    },
    SET_TEXTPNL_CONTACTINFO: (state, payload) => {
      state.dashboard.textpannel_contactinfo = payload;
    },
    SET_NOTFYPNL_CONTACTINFO: (state, payload) => {
      state.dashboard.notification_contactinfo = payload;
    },

    SET_NUMBER_BEING_CALLED: (state, payload) => {
      state.dashboard.number_being_called = payload;
    },
    SET_NUMBER_ONCHANGE_TEXTMESSG: (state, payload) => {
      state.dashboard.Onchange_textnumber = payload;
    },
    SET_ONCHANGETEXTNUMBER_STATUS: (state, payload) => {
      state.dashboard.Onchange_textnumberstatus = payload;
    },
    SET_FOCUSTEXT: (state, payload) => {
      state.dashboard.foucuson_text = payload;
    },
  },
  actions: {
    logout: (context) => {
      console.log("logged out store");
      //(this as any).$route.query.creds = '';
      //(this as any).$route.query.account_name ='';
      context.state.account.encrypted_creds = "";
      context.state.account.account_name = "";
      context.state.account.jwt = "";
      context.commit("LOGOUT_SUCCESS");
      context.commit("LOGOUT_STATUS", false);
      router.push("/login");
    },
    login: (context, payload) => {
      console.log("login", context);
      console.log("login payload", payload);
      // console.log('here is http', (Vue as any).$http);
      return new Promise((resolve, reject) => {
        context.commit("LOGIN_SENT");
        context.commit("SHOW_CONTACT_LIST", true);
        context.commit("SHOW_CONTACT_DETAIL", false);
        axios
          .post(`${AppSettings.API_HOST}login`, {
            creds: MD5(`${payload.username}:${payload.password}`),
            account_name: payload.account_name,
          })
          .then(async (response) => {
            if (response.data.success) {
              context.commit("LOGIN_SUCCESS", response);
              context.commit("SET_ACCOUNT_ID", response.data.account_id);

              context.state.account.encrypted_creds = MD5(
                `${payload.username}:${payload.password}`
              );
              context.state.account.account_name = payload.account_name;
              if (isElectron() && ipcRenderer) {
                await context.dispatch("getDevices");
                (ipcRenderer as any).send("login", {
                  creds: MD5(`${payload.username}:${payload.password}`),
                  account_name: payload.account_name,
                  devices: context.state.account.devices,
                });
              }
              resolve(response);
            } else {
              context.commit("LOGIN_FAIL", response);
              reject(response);
            }
          })
          .catch((failResponse) => {
            context.commit("LOGIN_FAIL", failResponse);
            reject(failResponse);
          });
      });
    },
    relogin: (context, payload) => {
      console.log("reloggedin");
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}login`, {
            creds: payload.creds,
            account_name: payload.account_name,
          })
          .then((response) => {
            if (response.data.success) {
              context.commit("LOGIN_SUCCESS", response);
              resolve(response);
            } else {
              console.log("failed with this response", response);
              context.commit("LOGIN_FAIL", response);
              reject();
            }
          })
          .catch((failResponse) => {
            // console.log('axios failed', failResponse);
            context.commit("LOGIN_FAIL", failResponse);
            reject();
          });
      });
    },
    kazooAPICall: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        const { action, data } = payload;
        try {
          // console.log('here is the token that is sent', context.state.account.jwt);
          const rv = await context.dispatch(action, data);
          // console.log('heres rv', rv);
          resolve(rv);
        } catch {
          reject();
        }
      });
    },

    getConferencedata: (context, payload) => {
      context.commit("SET_ADMIN_LOADER", true); //
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}conferences`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getConferencedata", payload);
              context.commit("SET_ADMIN_LOADER", false); //
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
              resolve(r);
            } else {
              const data = r.data.data[0];
              if (data != undefined) {
                axios.defaults.headers.common.Authorization =
                  "Bearer " + context.state.account.jwt;
                context.commit("SET_ADMIN_LOADER", false); //
                axios
                  .get(`${AppSettings.API_HOST}conferencesInfo/${data.id}`)
                  .then((r) => {
                    if ((r as any).data && (r as any).data.error === "401") {
                      replayAction("getConferencedata", payload);
                      //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
                      resolve(r);
                    } else {
                      context.commit("SET_ADMIN_LOADER", false); //
                      context.commit("SET_CONFERENCE", r.data.data); //
                      // context.commit('SHOW_CONTACT_INFOLOADER', false);
                      resolve(r);
                    }
                    // context.commit('SET_CONFERENCE', r.data.data[0]);//
                    // context.commit('SHOW_CONTACT_INFOLOADER', false);
                    //resolve(r);
                  });
              }
              context.commit("SET_ADMIN_LOADER", false); //
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            context.commit("SET_ADMIN_LOADER", false); //
            console.log("Could not retrieve Conference data");
            store.dispatch("getConferencedata", payload);

            reject(r);
          });
      });
    },

    getChannels: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}channels`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getChannels", payload);

              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
              resolve(r);
            } else {
              const data = r.data;
              if (data != undefined) {
                context.commit("SET_CHANNELS_ATTENDEE", data.data); //
                resolve(r);
              }
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);

            console.log("Could not retrieve Conference data");

            reject(r);
          });
      });
    },
    getCallflows: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}callflows`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getCallflows", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            console.log("Could not retrieve callflow data");
            reject(r);
          });
      });
    },

    getConferenceUsers: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}conferenceusers`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getConferenceUsers", payload);
              resolve(r);
            } else {
              let dataobj = { Users: [] };
              for (const doc of r.data.data) {
                dataobj.Users.push({
                  id: doc.id,
                  label: `${doc.first_name} ${doc.last_name}`,
                });
              }
              context.commit("SET_CONFERENCE_ATTENDEE", dataobj);
              store.dispatch("getConferenceDevices");
              resolve(r);
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            console.log("Could not retrieve Conference user List");
            reject(r);
          });
      });
    },
    getChannelDevices: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}conferencedevices`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getChannelDevices", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
              resolve(r);
            } else {
              context.commit("SET_CHANNEL_DEVICES", r.data.data);
              resolve(r);
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            console.log("Could not retrieve Conference user List");
            reject(r);
          });
      });
    },

    getConferenceDevices: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}conferencedevices`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getConferenceDevices", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
              resolve(r);
            } else {
              let dataobj = { Devices: [] };
              for (const doc of r.data.data) {
                dataobj.Devices.push({
                  id: doc.id,
                  label: doc.name,
                });
              }
              context.commit("SET_CONFERENCE_DEVICES", dataobj);
            }
          })
          .catch((r) => {
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            console.log("Could not retrieve Conference user List");
            reject(r);
          });
      });
    },

    inviteusers: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}conferencesInfo/${payload.id}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("updateconference", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
            } else {
              const id = r.data.data.id; //
              r.data.data.action = "dial";
              r.data.data.caller_id_name = r.data.data.name;
              r.data.data.endpoints = payload.endpoints;
              axios.defaults.headers.common.Authorization =
                "Bearer " + context.state.account.jwt;
              return axios
                .put(`${AppSettings.API_HOST}conferences/${id}`, {
                  data: JSON.stringify(r.data),
                })
                .then((r) => {
                  resolve(true);
                });
            }
            // context.commit('SET_CONFERENCE', r.data.data[0]);//
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            //resolve(r);
          });
      });
    },

    conferenceaction: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        return axios
          .post(
            `${AppSettings.API_HOST}conferenceaction/${payload.conferenceid}/${payload.action}/${payload.member_id}`
          )
          .then((r) => {
            //alert(JSON.stringify(r));
            resolve(r);
          });
      });
      // axios.defaults.headers.common.Authorization = 'Bearer ' + context.state.account.jwt;
      // return axios.post (`${AppSettings.API_HOST}conferenceaction/${payload.conferenceid}/${payload.action}/${payload.member_id}` ).then((r)=>{
      //     alert(r)
      //     return r;
      // });
    },

    updateconference: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;

        axios
          .get(`${AppSettings.API_HOST}conferencesInfo/${payload.id}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("updateconference", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false); //FEEDBACKMESSAGE_CONTACT
            } else {
              const id = r.data.data.id; //
              var conferencedata = r.data.data;
              r.data.data.member.join_muted = payload.join_muted;
              r.data.data.member.join_deaf = payload.join_deaf;
              r.data.data.play_entry_tone = payload.play_entry_tone;
              r.data.data.play_exit_tone = payload.play_exit_tone;

              //  r.data.data.moderator.pins=[];//[0]=payload.moderatorpin;
              //r.data.data.member.pins=[];//[0]=payload.memberpin;
              if (payload.moderatorpin.length > 0) {
                r.data.data.moderator.pins[0] = payload.moderatorpin;
              } else {
                r.data.data.moderator.pins = [];
              }
              if (payload.memberpin.length > 0) {
                r.data.data.member.pins[0] = payload.memberpin;
              } else {
                r.data.data.member.pins = [];
              }
              var tmp = { data: conferencedata };
              payload = tmp;

              axios.defaults.headers.common.Authorization =
                "Bearer " + context.state.account.jwt;
              axios
                .post(`${AppSettings.API_HOST}conferencesInfo/${id}`, {
                  data: JSON.stringify(r.data),
                })
                .then((r) => {
                  resolve(r);
                });
            }
            // context.commit('SET_CONFERENCE', r.data.data[0]);//
            // context.commit('SHOW_CONTACT_INFOLOADER', false);
            //resolve(r);
          });
      });
    },
    getKazooUser: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}getKazooUser`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            console.log("Could not retrieve users");
            reject(r);
          });
      });
    },
    getUsers: (context, payload) => {
      context.commit("SET_CONTACT_LOADER", true);
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        const accountid =
          payload && payload.id ? payload.id : context.state.account.account_id;
        axios
          .get(`${AppSettings.API_HOST}admin/accounts/${accountid}/users`)
          .then((r) => {
            context.commit("SET_CONTACT_LOADER", false);
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              context.commit("SET_DASHBOARD_USERS", r.data.docs);
              // context.commit("SET_ADMIN_LOADER", false);
              resolve(r);
            }
          })
          .catch((r) => {
            console.log("Could not retrieve users");
            reject(r);
          });
      });
    },
    ////Tag starst
    assigntag: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}contact/assign/tag`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },

    ////Tag starst
    assigntagmulti: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}multicontact/assign/tag`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },

    ////Tag delete from multiple contact
    deletetag_multicontact: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}multicontact/delete/tag`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },

    gettag: (context, payload) => {
      console.log("getting tag");
      return new Promise((resolve, reject) => {
        axios
          .get(`${AppSettings.API_HOST}tag/list`)
          .then((response) => {
            resolve(response);
            response.data.docs.filter(function (el) {
              el.select = false;
            });
            context.commit("TAG_LIST", response.data.docs);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },
    getUserId: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`${AppSettings.API_HOST}getUserId`)
          .then((response) => {
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },
    savetag: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`${AppSettings.API_HOST}tag/save/${payload}`)
          .then((response) => {
            let taglist = context.state.dashboard.Tag_list;
            taglist.push({
              tag: payload,
              _id: response.data.id,
              _rev: response.data.rev,
            });
            context.commit("TAG_LIST", taglist);
            console.log("taglistname" + taglist);
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },
    updatetag: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}tag/update`, payload)
          .then((response) => {
            let taglist = context.state.dashboard.Tag_list;
            taglist[
              taglist.map((e) => e._id).indexOf(payload.payload._id)
            ].tag = payload.payload.tag;
            context.commit("TAG_LIST", taglist);
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },
    deletetag: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${AppSettings.API_HOST}tag/delete`, payload)
          .then((response) => {
            let taglist = context.state.dashboard.Tag_list;
            taglist.splice(
              taglist.map((e) => e._id).indexOf(payload.payload._id),
              1
            );
            context.commit("TAG_LIST", taglist);
            resolve(response);
          })
          .catch((failResponse) => {
            reject(failResponse);
          });
      });
    },
    ///tah end
    loadmore_Contacts: (context, payload) => {
      context.commit("SET_CONTACT_LOADER", true);
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}loadmorecontacts/${payload.page}`)
          .then((r) => {
            const data = r.data;
            debugger;
            //context.commit('MERGE_contact', data.docs);//
            resolve(r);
          })
          .catch((r) => {
            context.commit("SHOW_CONTACT_INFOLOADER", false);
            context.commit("SET_CONTACT_LOADER", false);
            console.log("Could not retrieve contacts");
            reject(r);
          });
      });
    },
    getContacts: (context, payload) => {
      // context.commit('SET_CONTACT_LOADER', true);
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        await axios
          .get(`${AppSettings.API_HOST}contacts`)
          .then((r) => {
            // context.commit('SET_CONTACT_LOADER', false);
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getContacts", payload);
              //context.commit('SHOW_CONTACT_INFOLOADER', false);
              resolve(r);
            } else {
              const data = r.data;
              const created_tags = context.state.dashboard.Tag_list;

              data.Contact_Personal = data.docs.filter(function (el) {
                el.select = false; //by defaut false
                el.tags1 = [];
                if (el.taglist != undefined) {
                  created_tags.forEach((e1) =>
                    el.taglist.forEach((e2) => {
                      if (e1._id === e2) {
                        el.tags1.push(e1);
                      }
                    })
                  );
                }

                if (
                  el.Favoritecontact != undefined &&
                  el.Favoritecontact.length != 0
                ) {
                  el.Favoritecontact.filter(function (elmt) {
                    if (elmt == context.state.dashboard.logger_userid) {
                      el.pvt_cont = true;
                    } else {
                      el.pvt_cont = false;
                    }
                  });
                } else {
                  el.pvt_cont = false;
                }
                return el.owner_id == context.state.dashboard.logger_userid;
              });

              data.Contact_Shared = data.docs.filter(function (el) {
                el.select = false; //by defaut false
                el.tags1 = [];
                if (el.taglist != undefined) {
                  created_tags.forEach((e1) =>
                    el.taglist.forEach((e2) => {
                      if (e1._id === e2) {
                        el.tags1.push(e1);
                      }
                    })
                  );
                }
                if (
                  el.Favoritecontact != undefined &&
                  el.Favoritecontact.length != 0
                ) {
                  el.Favoritecontact.filter(function (elmt) {
                    if (elmt == context.state.dashboard.logger_userid) {
                      el.pvt_cont = true;
                    } else {
                      el.pvt_cont = false;
                    }
                  });
                } else {
                  el.pvt_cont = false;
                }
                return el.private == false;
              });

              data.Contact_Favorite = data.docs.filter(function (el) {
                el.select = false; //by defaut false
                return el.pvt_cont == true;
              });

              context.commit(
                "PERSONALCONTACT_COUNT",
                r.data.Contact_Personal.filter((e) => {
                  return !e.presence_id && e.private;
                }).length
              );
              context.commit(
                "PERSONALCONTACT_LIST",
                r.data.Contact_Personal.filter((e) => {
                  return !e.presence_id && e.private;
                })
              );
              context.commit(
                "PRESENCECONTACT_COUNT",
                r.data.Contact_Shared.filter((e) => {
                  return e.presence_id && !e.is_kazoo_deleted;
                }).length
              );

              context.commit(
                "SHAREDCONTACT_COUNT",
                r.data.Contact_Shared.filter((e) => {
                  return !e.presence_id && !e.private;
                }).length
              );
              context.commit(
                "SHAREDCONTACT_LIST",
                r.data.Contact_Shared.filter((e) => {
                  return !e.presence_id && !e.private;
                })
              );
              context.commit(
                "FAVORITECONTACT_COUNT",
                r.data.Contact_Favorite.length
              );
              context.commit("FAVORITECONTACT_LIST", r.data.Contact_Favorite);
              context.commit("SET_CONTACTS", data.docs); //
              // context.commit('SET_CONTACT_LOADER', false);

              resolve(r);
            }
          })
          .catch((r) => {
            context.commit("SHOW_CONTACT_INFOLOADER", false);
            // context.commit("SET_CONTACT_LOADER", false);
            console.log("Could not retrieve contacts");
            reject(r);
          });
      });
    },
    sendText: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      return axios
        .post(`${AppSettings.API_HOST}outbound_sms`, {
          payload: JSON.stringify(payload),
        })
        .then((r) => {
          return r;
        })
        .catch((r) => {
          console.log(r);
        });
    },
    getMsgReceipt: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      return axios
        .get(`${AppSettings.API_HOST}messageInfo/${payload}`)
        .then((r) => {
          return r;
        });
    },

    updateDeliveryStatus: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}updateDeliveryStatus`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("updateDeliveryStatus", payload);
              resolve(payload);
            } else {
              if (r.status === 200) {
                //  payload._rev = r.data.rev;
                //context.commit('UPDATE_CONTACT_INFORMATION', payload);
                resolve(r);
              }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    getPrivilegeLevel: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      axios.get(`${AppSettings.API_HOST}privilege`).then((r) => {
        context.commit("SET_PRIVILEGE_LEVEL", r.data);
      });
    },
    cancel_axios_request: (context, payload) => {
      source.cancel("Operation canceled by the user.");
    },
    getChatHistory: (context, payload) => {
      source = CancelToken.source(); //axios.CancelToken.source();
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        //for prod api
        // axios.post(`${AppSettings.API_HOST}messageHistory/`,
        // for dev api
        axios
          .post(
            `${AppSettings.API_HOST}getChatHistory/`,
            { payload: JSON.stringify(payload) },
            { cancelToken: source.token }
          )
          .then((r) => {
            r.data.forEach((doc) => {
              console.log(doc.media);
              if (doc.media != null || doc.media != undefined) {
                if (doc.media && doc.direction === "in") {
                  doc.media = doc.media
                    .filter((m) => m.indexOf(".smil") < 0)
                    .filter((m) => m.indexOf(".txt") < 0);
                  doc.media = doc.media.map((file) => {
                    const fileParts = file.split("/media/");
                    fileParts.shift();
                    // tslint:disable-next-line:max-line-length
                    return `${AppSettings.AWS_MMS_BUCKET}${context.state.account.account_id}/${fileParts[0]}`;
                  });
                }
              }

              var strdate = doc.time.substring(0, 10);
              doc.datex = strdate;
            });
            r.data.reverse().forEach((doc, index) => {
              var strdate = doc.datex;
              var index1 = r.data.findIndex((x) => x.datex === strdate);

              if (index1 == index) doc.displaydate = true;
              else doc.displaydate = false;
            });
            var icomin_mesg = r.data.filter((e) => e.direction === "in");
            // context.commit('SET_TEXT_HISTORY', icomin_mesg);
            // resolve(icomin_mesg);
            //context.commit('SET_TEXT_HISTORY', r.data);
            resolve(r.data);
          })
          .catch((r) => {
            console.log("Couldn't get the chat history", r);
            reject(r);
          });
      });
    },
    getTextHistory: (context, payload) => {
      source = CancelToken.source(); //axios.CancelToken.source();
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        //for prod api
        // axios.post(`${AppSettings.API_HOST}messageHistory/`,
        // for dev api
        axios
          .post(
            `${AppSettings.API_HOST}messageHistory_pricurnt/`,
            { payload: JSON.stringify(payload) },
            { cancelToken: source.token }
          )
          .then((r) => {
            r.data.forEach((doc) => {
              console.log(doc.media);
              if (doc.media != null || doc.media != undefined) {
                if (doc.media && doc.direction === "in") {
                  doc.media = doc.media
                    .filter((m) => m.indexOf(".smil") < 0)
                    .filter((m) => m.indexOf(".txt") < 0);
                  doc.media = doc.media.map((file) => {
                    const fileParts = file.split("/media/");
                    fileParts.shift();
                    // tslint:disable-next-line:max-line-length
                    return `${AppSettings.AWS_MMS_BUCKET}${context.state.account.account_id}/${fileParts[0]}`;
                  });
                }
              }

              var strdate = doc.time.substring(0, 10);
              doc.datex = strdate;
            });
            r.data.reverse().forEach((doc, index) => {
              var strdate = doc.datex;
              var index1 = r.data.findIndex((x) => x.datex === strdate);

              if (index1 == index) doc.displaydate = true;
              else doc.displaydate = false;
            });
            var icomin_mesg = r.data.filter((e) => e.direction === "in");
            // context.commit('SET_TEXT_HISTORY', icomin_mesg);
            // resolve(icomin_mesg);
            context.commit("SET_TEXT_HISTORY", r.data);
            resolve(r.data);
          })
          .catch((r) => {
            console.log("Couldn't get the text history", r);
            reject(r);
          });
      });
    },
    checkForNewTexts: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}newMessages/`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            // console.log(r.data.call1);
            if (
              r.data.call1.messages.length > 0 ||
              r.data.call2.messages.length > 0
            ) {
              // console.log('getting here');
              let messageHistory = processTexts(r);
              messageHistory = messageHistory.filter((e) => {
                // tslint:disable-next-line:max-line-length
                if (
                  context.state.dashboard.text_history.find(
                    (message) => (e as any).id === (message as any).id
                  ) !== undefined
                ) {
                  return false;
                } else {
                  return true;
                }
              });
              context.commit("APPEND_NEW_TEXTS", messageHistory);
              resolve(true);
            } else {
              resolve(false);
            }
          });
      });
    },
    loadMoreTexts: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}loadMoreTexts`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            r.data.forEach((doc) => {
              if (doc.media && doc.direction === "in") {
                doc.media = doc.media
                  .filter((m) => m.indexOf(".smil") < 0)
                  .filter((m) => m.indexOf(".txt") < 0);
                doc.media = doc.media.map((file) => {
                  const fileParts = file.split("/media/");
                  fileParts.shift();
                  // tslint:disable-next-line:max-line-length
                  return `${AppSettings.AWS_MMS_BUCKET}${context.state.account.account_id}/${fileParts[0]}`;
                });
              }
              var strdate = doc.time.substring(0, 10);
              doc.datex = strdate;
            });
            r.data.reverse().forEach((doc, index) => {
              var strdate = doc.datex;
              var index1 = r.data.findIndex((x) => x.datex === strdate);
              if (index1 == index) doc.displaydate = true;
              else doc.displaydate = false;
            });
            context.commit("MERGE_TEXTS", r.data);
            resolve(r);
          });
      });
    },

    getDailyreport: (context, payload) => {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.account.jwt;

      return new Promise((resolve, reject) => {
        const enddate = Math.round(payload.endDate);
        return axios
          .get(
            `${AppSettings.API_HOST}dailyreport/${payload.startDate}/${enddate}`
          )

          .then((r) => {
            resolve(r);
          })
          .catch((r) => {
            // context.commit('SHOW_DOWNLOAD_SPIN',  false);
            reject(r);
          });
      });
    },
    getCallReports: (context, payload) => {
      context.commit("CALL_REPORTS_SENT");
      //context.commit("CALLREPORT_SLIDER", true);
      const query = buildLuceneQuery();
      let shouldContinue = payload.para.hasOwnProperty("shouldContinue")
        ? payload.para.shouldContinue
        : false;
      let monthindex = payload.para.hasOwnProperty("monthindex")
        ? payload.para.monthindex
        : context.state.reports.monthyearindex;
      let search = payload.para.hasOwnProperty("searchtext")
        ? payload.para.searchtext
        : context.state.reports.searchtext;

      if (payload.hasOwnProperty("startDate") && query.length > 0) {
        for (let i = 0; i < query.length; i++) {
          if (query[i].indexOf("startTime") > -1)
            query[i] = "startTime=" + payload.startDate;
        }
      }
      if (payload.hasOwnProperty("endDate") && query.length > 0) {
        for (let i = 0; i < query.length; i++) {
          if (query[i].indexOf("endTime") > -1)
            query[i] = "endTime=" + payload.endDate;
        }
      }
      const { showLoadMoreBar } = context.state.reports;
      let { bookmark } = context.state.reports;
      let page = payload.para.hasOwnProperty("Page") ? payload.para.Page : 0;
      let _status = false;
      // tslint:disable-next-line:no-string-literal

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.account.jwt;
      return new Promise((resolve, reject) => {
        {
          // History Work
          if (shouldContinue && bookmark !== null && bookmark.length > 0) {
            query.push(`bookmarks=${bookmark}`);
          }
          if (page >= 0) {
            // context.commit('SHOW_PROGRESS_BAR_VISIBLE', { isVisible: true,});
          }
          if (page < 0) query.push(`download=1`);
          if (payload.hasOwnProperty("kazoouserlistids")) {
            const kazoouserlistids = payload.kazoouserlistids.join(",");
            query.push(`kazoouserlistids=` + kazoouserlistids);
          }

          if (search) query.push(`search=` + search);
          context.commit("CALLREPORT_SLIDER", true);
          return axios
            .get(
              `${AppSettings.API_HOST}getCallReports${
                query.length > 0 ? `?${query.join("&")}` : ""
              }`
            )
            .then((r) => r.data)
            .then((r) => {
              context.commit("CALLREPORT_SLIDER", false);

              const cdrs = r.cdrs;
              const total = r.total;
              const monthlist = r.mys;

              if (r.bookmarks) {
                context.commit("SHOW_DOWNLOAD_SPIN", false);
                bookmark = JSON.stringify(r.bookmarks);
                context.commit("SET_BOOKMARK", { bookmark });
              }
              context.commit("SET_CURRENT_FILTERS_RUN", { filtersRun: true });

              // Set this equal to the cdr query limit, not a magic number
              if (cdrs.length !== AppSettings.cdr_query_limit) {
                //context.commit('SHOW_DOWNLOAD_SPIN',  false);
                context.commit("LOAD_MORE_BAR_VISIBLE", { isVisible: false });
              } else if (showLoadMoreBar === false) {
                context.commit("LOAD_MORE_BAR_VISIBLE", { isVisible: true });
              }
              if (page < 0) {
                //context.commit('SHOW_DOWNLOAD_SPIN',  false);
                context.commit("UPDATE_CALL_REPORTS_DOWNLOADS", {
                  cdrs,
                  total,
                });
              } else if (shouldContinue) {
                const currentCDRs = [
                  ...context.state.reports.callReports,
                ] as any;
                currentCDRs.push(...cdrs);

                context.commit("UPDATE_CALL_REPORTS", { cdrs });
                context.commit("LOADING_MORE", { loadingMore: false });
              } else {
                /* Refreshing issue/Double keypress issue
                 * after load more data again RUN a report the previous loaded data was binding in the list
                 * its happening becouse of  bookmark
                 * just test it once again , discuss clearing the data
                 */
                context.commit("UPDATE_CALL_REPORTS", {
                  cdrs: [],
                  total: 0,
                  monthindex: 0,
                  clear: true,
                });
                context.commit("UPDATE_CALL_REPORTS", {
                  cdrs,
                  total,
                  monthindex,
                });

                if (
                  context.state.reports.filters.inboundChecked ||
                  (!context.state.reports.filters.inboundChecked &&
                    !context.state.reports.filters.outboundChecked)
                ) {
                  /* Double keypress issue
                   * just test it once again , discuss clearing the data
                   */

                  //  context.dispatch("getVoicemails_callrep");
                  if (context.state.reports.filters.extensionsList.length > 0) {
                    /* with respective Extention-enable bind the voicemail data */
                    var Extention_EnbleName =
                      context.state.dashboard.userfirstname +
                      " " +
                      context.state.dashboard.userlastname;
                    context.state.reports.filters.extensionsList.forEach(
                      (doc) => {
                        if (doc.ext == Extention_EnbleName && doc.value) {
                          context.dispatch("getVoicemails_callrep");
                        }
                      }
                    );
                  }
                }
                if (page === 0) {
                  context.commit("UPDATE_MONTH_LIST", { monthlist });
                }
              }
              resolve(r);
            })
            .catch((r) => {
              // context.commit('SHOW_DOWNLOAD_SPIN',  false);
              reject(r);
            });
        }
      });
    },

    getSettings: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}settings`)
          .then(async (r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getSettings", payload);
            } else {
              //console.log(JSON.stringify(r))
              context.commit("SET_SETTINGS", r.data);
              context.commit("SET_USER_LAST_NAME", r.data.data.last_name);
              context.commit("SET_USER_FIRST_NAME", r.data.data.first_name);
              context.commit("SET_LOGGER_USER_ID", r.data.data.id);
              context.commit("SET_USER_IMAGE", r.data.data.imageUrl);
              // alert(r.data.data)
              await store.dispatch("getDevices");
            }
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    uploadAvatar: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}uploadAvatar`, payload, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(async (r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("uploadAvatar", payload);
            }
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    updateSettings: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}updateSettings`, payload)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("updateSettings", payload);
            } else {
              context.commit("SET_SETTINGS", r.data);
            }
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    updateImageSettings: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}updateUserImage`, payload)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("updateUserImage", payload);
            } else {
            }
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    getDevices: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}devices`, payload)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getDevices", payload);
            } else {
              const devicesToCommit = [];
              const data = r.data;
              const devices = JSON.parse(r.data.devices).data;
              const deviceStatus = JSON.parse(r.data.device_status).data;
              if (devices.message !== "invalid credentials") {
                for (const device of devices) {
                  const d = deviceStatus.find((e) => e.device_id === device.id);
                  if (typeof d !== "undefined") {
                    device.registered = d.registered;
                  } else {
                    device.registered = false;
                  }
                  devicesToCommit.push(device as never);
                }
                context.commit("SET_DEVICES", devicesToCommit);
                resolve(devicesToCommit);
              } else {
                reject();
              }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    quickCall: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(
            `${AppSettings.API_HOST}quickCall/${payload.device}/${payload.phone_number}`
          )
          .then((r) => {
            // console.log(r);
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    Download_paly: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `${AppSettings.API_HOST}downloadfile/`,
          method: "Post",
          responseType: "blob",
          data: { fileurl: payload }, // important
        })
          .then((response) => {
            resolve(response);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    getCallHistory: (context, payload) => {
      return new Promise((resolve, reject) => {
        let query = "";
        if (payload && payload.bookmarks) {
          query = `?bookmarks=${payload.bookmarks}`;
        }
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}callHistory${query}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getCallHistory", payload);
              resolve(r);
            } else {
              if (r.data.cdrs.length >= AppSettings.cdr_query_limit) {
                context.commit("CALL_HISTORY_LOAD_MORE_VISIBLE", true); //CALL_HISTORY_LOADER
              } else {
                context.commit("CALL_HISTORY_LOAD_MORE_VISIBLE", false);
              }
              if (payload == undefined) {
                context.commit("SET_CALL_HISTORY", r.data);
                //context.dispatch("getVoicemails");
              } else {
                context.commit("SET_CALL_HISTORY_LOADMORE", r.data);
              }
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    getMyCallHistory: (context, payload) => {
      context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", true);
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        if (payload && payload.start_date && payload.end_date) {
          axios
            .get(
              `${AppSettings.API_HOST}myCallHistory/${payload.start_date}/${payload.end_date}`
            )
            .then((r) => {
              if ((r as any).data && (r as any).data.error === "401") {
                replayAction("getMyCallHistory", payload);
              } else {
                if (r.data.cdrs.length >= AppSettings.cdr_query_limit) {
                  context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", true); //
                } else {
                  context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", false);
                }
                context.commit("SET_MY_CALL_HISTORY", r.data);
                context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
                resolve(r);
              }
            })
            .catch((r) => {
              context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
              reject(r);
            });
        } else {
          axios
            .get(`${AppSettings.API_HOST}myCallHistory`)
            .then((r) => {
              if (r.data.cdrs.length >= AppSettings.cdr_query_limit) {
                context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", true);
              } else {
                context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", false);
              }
              context.commit("SET_MY_CALL_HISTORY", r.data);
              context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
              resolve(r);
            })
            .catch((r) => {
              context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
              reject(r);
            });
        }
      });
    },
    loadMoreMyCallHistory: (context, payload) => {
      context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", true);
      return new Promise((resolve, reject) => {
        let query = "";
        if (payload && payload.bookmarks) {
          query = `?bookmarks=${payload.bookmarks}`;
        }
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}myCallHistory${query}`, payload)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("loadMoreMyCallHistory", payload);
            } else {
              if (r.data.cdrs.length >= AppSettings.cdr_query_limit) {
                context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", true);
              } else {
                context.commit("MY_CALL_HISTORY_LOAD_MORE_VISIBLE", false);
              }
              context.commit("APPEND_MY_CALL_HISTORY", r.data);
              context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
              resolve(r);
            }
          })
          .catch((r) => {
            context.commit("MY_CALL_HISTORY_LOADER_VISIBLE", false);
            reject(r);
          });
      });
    },
    getvoicemailaudioattachment: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(
            `${AppSettings.API_HOST}voicemailaudioattachment/${payload.media_id}/${payload.my}`
          )
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getvoicemailaudioattachment", payload);
            } else {
              (r as any).data.APIServer = AppSettings.API_HOST;

              resolve(r);
            }
          });
      });
    },
    getVoicemailAudio: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(
            `${AppSettings.API_HOST}voicemailaudio/${payload.media_id}/${payload.my}`
          )
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getVoicemails", payload);
            } else {
              resolve(r);
            }
          });
      });
    },

    getVoicemails: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}voicemails`, payload)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getVoicemails", payload);
            } else {
              const vm_id = r.data.vm_id;
              const body = JSON.parse(r.data.body);
              const voicemails = body.data.filter((e) => {
                return e.folder && (e.folder === "new" || e.folder === "saved");
              });
              context.commit("SET_VM_ID", vm_id);
              context.commit("SET_VOICEMAILS", voicemails);
              if (context.state.reports.filters.extensionsList.length > 0) {
                /* with respective Extention-enable bind the voicemail data */
                var Extention_EnbleName =
                  context.state.dashboard.userfirstname +
                  " " +
                  context.state.dashboard.userlastname;
                context.state.reports.filters.extensionsList.forEach((doc) => {
                  if (doc.ext == Extention_EnbleName && doc.value) {
                    context.commit(
                      "SET_VOICEMAILS_REPORT_DOWNLOAD",
                      voicemails
                    );
                  }
                });
              }
              resolve(r);
            }
          })
          .catch((r) => {
            // reject(r);
            resolve(r);
          });
      });
    },
    getVoicemails_callrep: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios.get(`${AppSettings.API_HOST}voicemails`, payload).then((r) => {
          if ((r as any).data && (r as any).data.error === "401") {
            replayAction("getVoicemails", payload);
          } else {
            const vm_id = r.data.vm_id;
            const body = JSON.parse(r.data.body);
            const voicemails = body.data.filter((e) => {
              return e.folder && (e.folder === "new" || e.folder === "saved");
            });
            context.commit("SET_VM_ID", vm_id);

            context.commit("SET_VOICEMAILS_REPO", voicemails);

            resolve(r);
          }
        });
      });
    },

    deleteVoicemail: async (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .delete(
            `${AppSettings.API_HOST}voicemail/${context.state.account.vm_id}/${payload.vm_id}`
          )
          .then(async (r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("deleteVoicemail", payload);
            } else {
              delete axios.defaults.headers.common.Authorization;
              // tslint:disable-next-line:max-line-length
              await axios.get(
                `https://vt6rhvynu6.execute-api.us-west-2.amazonaws.com/prod/deleteVoicemailAudio?vm=${context.state.account.account_id}/${context.state.account.vm_id}/${payload.vm_id}.m4a`
              );
              context.commit("REMOVE_VOICEMAIL", payload.vm_id);
              resolve(r);
            }
          });
      });
    },
    markVoicemailAsRead: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(
            `${AppSettings.API_HOST}markVoicemailAsRead/${context.state.account.vm_id}/${payload}`
          )
          .then(async (r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("markVoicemailAsRead", payload);
            } else {
              resolve(true);
            }
          });
      });
    },
    getNotes: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}notes/${payload.id}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getNotes", payload);
            } else {
              r.data.sort((a, b) => {
                if (a.last_updated === b.last_updated) {
                  return 0;
                }
                return a.last_updated > b.last_updated ? -1 : 1;
              });
              context.commit("SET_NOTES", r.data);
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    // saveNote: (context, payload) => {
    //     axios.defaults.headers.common.Authorization = 'Bearer ' + context.state.account.jwt;
    //     axios.post(`${AppSettings.API_HOST}saveNote`, payload).
    //         then((r) => {
    //             if ((r as any).data && (r as any).data.error === '401') {
    //                 replayAction('saveNote', payload);
    //             } else {
    //                 if (r.data.rev) {
    //                     (context.state.dashboard.selectedContact as any)._rev = r.data.rev;
    //                     const contact = context.state.dashboard.contacts
    //                         .find((e) => (e as any)._id === (context.state.dashboard.selectedContact as any)._id);
    //                     (contact as any)._rev = r.data.rev;
    //                 }
    //                 r.data.notes.sort(noteSort);
    //                 context.commit('SET_NOTES', r.data.notes);
    //             }
    //         });
    // },

    saveNote: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}saveNote`, payload)
          .then((r) => {
            context.commit("LOADING_NOTES_STATUS", false);
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("saveNote", payload);
            } else {
              if (r.data.rev) {
                (context.state.dashboard.selectedContact as any)._rev =
                  r.data.rev;
                const contact = context.state.dashboard.contacts.find(
                  (e) =>
                    (e as any)._id ===
                    (context.state.dashboard.selectedContact as any)._id
                );
                (contact as any)._rev = r.data.rev;
              }
              var filtered = r.data.notes.filter(function (el) {
                return el != null;
              });
              filtered.sort(noteSort);
              context.commit("SET_NOTES", filtered);
              context.dispatch("getContacts");
            }
          })
          .catch((failResponse) => {
            context.commit("LOADING_NOTES_STATUS", false);

            reject(failResponse);
          });
      });
    },

    deleteNote: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      axios
        .delete(
          `${AppSettings.API_HOST}deleteNote/${payload.id}/${payload.rev}/${payload.contact}`
        )
        .then((r) => {
          context.commit("LOADING_NOTES_STATUS", false);
          if ((r as any).data && (r as any).data.error === "401") {
            replayAction("deleteNote", payload);
          } else {
            if (r.data.rev && context.state.dashboard.selectedContact) {
              (context.state.dashboard.selectedContact as any)._rev =
                r.data.rev;
              const contact = context.state.dashboard.contacts.find(
                (e) =>
                  (e as any)._id ===
                  (context.state.dashboard.selectedContact as any)._id
              );
              (contact as any)._rev = r.data.rev;
            }
            r.data.notes.sort(noteSort);
            context.commit("SET_NOTES", r.data.notes);
            context.dispatch("getContacts");
          }
        });
    },
    deleteContact: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        await axios
          .delete(
            `${AppSettings.API_HOST}deleteContact/${payload.id}/${payload.rev}`
          )
          .then((r) => {
            resolve(r);
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    getAccExtensions: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        return axios
          .get(`${AppSettings.API_HOST}admin/accounts/ext`)
          .then((r) => {
            resolve(r.data);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    getExtensions: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        return axios
          .get(`${AppSettings.API_HOST}extensions`)
          .then((r) => {
            let extensions: Extension[] = r.data;
            extensions = transformExtensionList(extensions);

            var extensions_copy1 = JSON.parse(JSON.stringify(extensions));

            console.log("Ext cpy --- ", extensions_copy1);

            var Extention_EnbleName =
              context.state.dashboard.userfirstname +
              " " +
              context.state.dashboard.userlastname;

            // const thisExt = extensions_copy1.filter(e => e.value=true   );//by defoult select all extensions
            const thisExt = extensions_copy1.filter((e) =>
              e.ext == Extention_EnbleName
                ? (e.value = true)
                : (e.value = false)
            ); //by defoult select all extensions

            //For Run report
            context.commit("UPDATE_EXTENSIONS_LIST", {
              extensions: extensions_copy1.slice(),
            });

            //For Schedule report
            var extensions_copy2 = JSON.parse(JSON.stringify(extensions));

            context.commit("UPDATE_EXTENSIONS_LIST_SCHEDULE", {
              extensions: extensions_copy2,
            });
            resolve(r);
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    submitContactChanges: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        await axios
          .patch(`${AppSettings.API_HOST}updateContact`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("submitContactChanges", payload);
              resolve(r);
            } else {
              payload._rev = r.data.rev;
              if (r.status === 200) {
                // context.commit('UPDATE_CONTACT_INFORMATION', payload);
                resolve(r);
              }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    ContactInfo: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}ContactInfo/${payload._id}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
              //  if (r.status === 200) {
              //      payload._rev = r.data.rev;
              //      resolve(r);
              //  }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    createContactFromNumber: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}createContactFromNumber`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("createContactFromNumber", payload);
            } else {
              context.commit("ADD_CONTACTS", [r.data]);
              context.commit("CHANGE_SELECTED_CONTACT", r.data);
            }
          });
      });
    },

    addCaller: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        await axios
          .post(`${AppSettings.API_HOST}addCallerToContacts`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("addCaller", payload);
              resolve(r);
            } else {
              context.commit("ADD_CONTACTS", [r.data]);
              context.commit("CHANGE_SELECTED_CONTACT", r.data);
              r.data.firstname = payload.fname;
              r.data.lastname = payload.lname;
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    addtoshareContac: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}addSharedContact`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    addtoFavoritContac: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}addFavoriteCont/${payload}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
              //  if (r.status === 200) {
              //      payload._rev = r.data.rev;
              //      resolve(r);
              //  }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    removeFavoritContac: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .get(`${AppSettings.API_HOST}removeFavoritContac/${payload}`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    assignTagtoContact: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .patch(`${AppSettings.API_HOST}contactDetailtagassign`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              if (r.status === 200) {
                payload._rev = r.data.rev;
                // context.commit('UPDATE_CONTACT_INFORMATION', payload);
                resolve(r);
              }
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    tagmenu: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}createTag`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    newNotification: async (context, payload) => {
      const id = payload._id;
      const num = payload.from; //from no
      const socketRoom = payload.to; //to - socket room
      const d = new Date(payload.time);
      const direction = payload.direction;
      const timeModified = payload.timeModified;
      const time = moment(d).format("MM/DD/YY"); //moment(d).format("YYYY-MM-DD");;//MM/DD/YY
      const timestamp = moment(d).format("MM/DD/YY hh:mm a"); // payload.timestamp;
      const read = payload.read;
      //console.log('payload in newNotifications',payload);
      // tslint:disable-next-line:max-line-length
      const timetofocus_ontext = payload.time;
      const displayTimestamp = moment(new Date()).isAfter(d, "day")
        ? `${moment(d).format("MM/DD/YY")}`
        : `Today ${moment(d).format("h:mm A")}`;
      let contact: any = {};
      if (direction == "in") {
        contact = await getNotificationContact(num);
      } else {
        contact = await getNotificationContact(socketRoom); //left side message show
      }

      let displayName = ""; //num;
      let imageUrl = ""; //num;
      if (contact) {
        displayName = `${contact.first_name} ${contact.last_name}`;
      }
      if (contact) {
        imageUrl = `${contact.imageUrl}`;
        imageUrl = imageUrl === "undefined" ? "" : imageUrl;
        imageUrl =
          contact.contact_status == "new_contact" && imageUrl == ""
            ? "new_contact"
            : imageUrl; // for new contact
      }
      const eventType = payload.eventType;
      var Tooltip;
      if (payload.eventType == "mms") {
        const media = payload.media[0];
        const fileParts = media.split("/media/");
        fileParts.shift(); //'Media' ;//
        //Tooltip='Media' ;
        //Tooltip= 'Attachment: Image';//payload.text;
        Tooltip =
          payload.deliveryState == "failed"
            ? "Message Failed to Send"
            : "Attachment: Image";
      }
      if (payload.eventType == "vm") {
        Tooltip = "Voice Mail";
      }
      if (payload.eventType == "sms") {
        Tooltip = payload.text;
      }

      const new_date = moment().subtract(7, "d").format("MM/DD/YY");
      const previous_day = displayTimestamp >= new_date;
      var today = moment(new Date()).isAfter(d, "day");
      var dayname = !(previous_day && !today)
        ? new Date(displayTimestamp).toLocaleString("en-us", {
            weekday: "long",
          })
        : `Today`;
      let deliveryState = payload.deliveryState ? payload.deliveryState : "";
      const notification = {
        displayTimestamp,
        contact,
        displayName,
        today,
        imageUrl,
        id,
        direction,
        socketRoom,
        number: num,
        timestamp,
        eventType,
        read,
        time: time,
        tooltip: Tooltip,
        timetofocus_ontext: timetofocus_ontext,
        timeModified: timeModified,
        dayname: dayname,
        previous_day: previous_day,
        deliveryState: deliveryState,
      };

      context.commit("NEW_NOTIFICATION", notification);
      context.commit("SET_NOTIFICATION_STATUS");
    },
    addNotificationContact: (context, payload) => {
      return new Promise((resolve, reject) => {
        payload = {
          fname: util.formatPhoneNumber(payload),
          lname: "",
          number: payload,
          mobile: payload,
          private: true,
        };
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}addCallerToContacts`, {
            payload: JSON.stringify(payload),
          })
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("addNotificationContact", payload);
            } else {
              context.commit("ADD_CONTACTS", [r.data]);
              resolve(r.data);
            }
          });
      });
    },
    getTextPermissions: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        return axios
          .get(`${AppSettings.API_HOST}textPermissions`)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("getTextPermissions", payload);
            } else {
              context.commit("SET_TEXT_PERMISSIONS", r.data);
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    setAdminHellospokeAccounts: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      return axios
        .get(`${AppSettings.API_HOST}admin/accounts`)
        .then((r) => {
          // console.log(r);
          if ((r as any).data && (r as any).data.error === "401") {
            replayAction("setAdminHellospokeAccounts", payload);
          } else {
            context.commit("SET_ADMIN_HELLOSPOKE_ACCOUNTS", r.data.data);
          }
        })
        .catch((r) => {
          console.warn(r);
        });
    },

    setScheduleFrequency: (context, payload) => {
      context.commit("SET_SCHEDULE_DAILY", {
        daily: payload.daily,
      });
      context.commit("SET_SCHEDULE_WEEKLY", {
        weekly: payload.weekly,
      });
      if (!payload.weekly) {
        context.commit("SET_SCHEDULE_DAY", "");
      }
      context.commit("SET_SCHEDULE_MONTHLY", {
        monthly: payload.monthly,
      });
      if (!payload.monthly) {
        context.commit("SET_MONTHLY_DELIVERY", {
          frequency: "none",
        });
      }
      //uncheck weekly freq on reset
      context.state.reports.scheduleForm.WeeklyDays_EnalbeList.forEach(
        function (e1) {
          e1.value = false;
        }
      );
    },
    setMonthlyFrequency: (context, { frequency }) => {
      context.commit("SET_MONTHLY_DELIVERY", {
        frequency,
      });
    },
    saveReportAsScheduled: (context, payload) => {
      let replace = false;
      if (payload) {
        replace = payload.replace;
      }
      const query = buildLuceneQuery(false);
      const { filename, email } = context.state.reports.scheduleForm;
      let lQuery = "";
      if (query.length > 0) {
        lQuery = `?${query.join("&")}`;
      }
      const duplicateReport =
        context.state.reports.scheduledReports.find(
          (r) => (r as any).filename === filename
        ) || null;
      if (duplicateReport !== null && !replace) {
        context.state.reports.showReplaceModal = true;
        // TODO: Show this modal properly
        // this.showReplaceReportModal.next({
        //     id: duplicateReport['_id'],
        //     rev: duplicateReport['_rev']
        // });
        context.state.reports.replaceFilename = filename;
        context.state.reports.showReplaceModal = true;
        return Promise.resolve(false);
      }
      if (replace) {
        context.state.reports.showReplaceModal = false;
      }

      const reportBundle: ReportDataBundle = {
        email_address: email,
        filename,
        filters: getFilters(context.state.reports.filters as any, email),
        lucene_query: lQuery,
        // tslint:disable-next-line:max-line-length
        frequency: getFrequency(
          context.state.reports.scheduleForm as any,
          context.state.reports.filters.timezone as Timezone
        ),
        pvt_type: "scheduled_report",
        schedule_startDate: context.state.reports.filters.startDate_Schedul,
        schedule_endDate: context.state.reports.filters.endDate_Schedul,
      };

      // return axios.post(`${AppSettings.API_HOST}saveScheduledReport`, reportBundle)
      //     .then((r) => {
      //         alert(r)
      //         context.dispatch('getScheduledReports');
      //     });
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}saveScheduledReport`, reportBundle)
          .then((r) => {
            if ((r as any).data && (r as any).data.error === "401") {
              replayAction("addCaller", payload);
              resolve(r);
            } else {
              resolve(r);
            }
          })
          .catch((r) => {
            reject(r);
          });
      });
    },

    replaceScheduledReport: (context, payload) => {
      const query = buildLuceneQuery(false);
      const { filename, email } = context.state.reports.scheduleForm;
      let lQuery = "";
      if (query.length > 0) {
        lQuery = `?${query.join("&")}`;
      }
      const duplicateReport =
        context.state.reports.scheduledReports.find(
          (r) => (r as any).filename === filename
        ) || null;
      context
        .dispatch("deleteScheduledReport", {
          id: (duplicateReport as any)._id,
          rev: (duplicateReport as any)._rev,
        })
        .then(() => {
          context.dispatch("saveReportAsScheduled").then(() => {
            context.state.reports.showReplaceModal = false;
          });
        });
    },
    getScheduledReports: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      axios.get(`${AppSettings.API_HOST}scheduledReports`).then((r) => {
        if ((r as any).data && (r as any).data.error === "401") {
          replayAction("getScheduledReports", payload);
        } else {
          const reports = r.data.docs;
          // console.log('here\'s the reports', reports);
          context.state.reports.scheduledReports = reports;
        }
      });
    },
    getScheduledReport: (context, payload) => {
      const id = payload.id;
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      axios.get(`${AppSettings.API_HOST}scheduledReports/${id}`).then((r) => {
        if ((r as any).data && (r as any).data.error === "401") {
          replayAction("getScheduledReport", payload);
        } else {
          const report = r.data;
          // console.log('Got a report back', r);
          const filters = report.filters;
          // tslint:disable-next-line:max-line-length
          //(context.state.reports.filters.extensionsList as any) = context.state.reports.filters.extensionsList.map((e) => {
          (context.state.reports.filters.extensionsList_schedul as any) =
            context.state.reports.filters.extensionsList_schedul.map((e) => {
              return {
                ext: (e as any).ext,
                value:
                  filters.extensions.indexOf((e as any).ext) >= 0
                    ? true
                    : false,
              } as Extension;
            });
          context.commit("LOAD_REPORT", {
            filters,
            report,
          });
        }
      });
    },
    deleteScheduledReport: (context, payload) => {
      const id = payload.id;
      const rev = payload.rev;
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      return axios
        .delete(`${AppSettings.API_HOST}scheduledReports/${id}/${rev}`)
        .then((r) => {
          if ((r as any).data && (r as any).data.error === "401") {
            replayAction("deleteScheduledReport", payload);
          } else {
            if (r.status === 200) {
              context.commit("DELETE_SCHEDULED_REPORT", { id });
            }
            context.commit("DELETE_MODAL_HIDE");
          }
        });
    },

    verifyJWT: (context, payload) => {
      var tkn = context.state.account.jwt;
      verifyToken(context, tkn);
    },
    createBlackholeSocket: (context, payload) => {
      var AttendeeSectionList = context.state.dashboard.AttendeeSectionList;
      if (!isElectron()) {
        if (
          (context.state.dashboard as any).blackhole_socket !== null &&
          typeof (context.state.dashboard as any).blackhole_socket !==
            "undefined"
        ) {
          // return;
        }
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        return axios.get(`${AppSettings.API_HOST}socketInfo`).then((r) => {
          const socket = new WebSocket("wss://api.hellospoke.com:5443");
          (context.state.dashboard as any).blackhole_socket = socket;
          const token = r.data.token;
          const account_id = r.data.account_id;
          const user_id = r.data.user_id;
          function send(data) {
            socket.send(JSON.stringify(data));
          }
          const _conferenceid =
            (context.state.dashboard as any).ConferenceData &&
            (context.state.dashboard as any).ConferenceData.id
              ? (context.state.dashboard as any).ConferenceData.id
              : "dd";
          socket.onopen = () => {
            send({
              action: "subscribe",
              auth_token: token,
              data: {
                account_id,
                binding: "call.*.*",
                owner_id: user_id,
              },
            });
            send({
              action: "subscribe",
              auth_token: token,
              data: {
                account_id,
                binding: "conference.event." + _conferenceid + ".*",
              },
            });
          };

          socket.onmessage = (rawMessage) => {
            //  alert('processCall')
            const jsonData = JSON.parse(rawMessage.data);
            // console.log(jsonData);
            if (jsonData.name && jsonData.name === "CHANNEL_CREATE") {
              processCall(jsonData);
            } else if (jsonData.name && jsonData.name === "CHANNEL_DESTROY") {
              endCall(jsonData);
            } else if (jsonData.name && jsonData.name === "event") {
              if (jsonData.data && jsonData.data.event) {
                if (jsonData.data.event === "add-member")
                  processConferenceCall(jsonData, AttendeeSectionList);
                else if (jsonData.data.event === "stop-talking")
                  processSttendeeStopTalking(jsonData);
                else if (jsonData.data.event === "start-talking")
                  processSttendeeStartTalking(jsonData);
                else if (jsonData.data.event === "del-member")
                  processAttendeeRemove(jsonData);
              }
            }
          };
        });
      } else {
        // console.log('its electron');
        // console.log(ipcRenderer);
        ipcRenderer.send("blackholeInit", { jwt: context.state.account.jwt });
      }
    },
    createNotificationsSocket: (context, payload) => {
      if (
        context.state.dashboard.notifications_socket !== null &&
        typeof context.state.dashboard.notifications_socket !== "undefined"
      ) {
        // return;
      }
      context.state.dashboard.notifications_socket = io(
        `${AppSettings.websocketServer}`
      );
      const wsSocket = context.state.dashboard.notifications_socket;
      // (wsSocket as any).on('test ws connection', async (message) => {
      //     console.log(message);
      // });
      for (const textPermission of context.state.account.text_permissions) {
        if (
          (textPermission as any).text_permissions_level !== "none" &&
          (textPermission as any).text_permissions_level !== "unset"
        ) {
          const num = (textPermission as any).phone_number;
          // console.log(`registering ${num}`);
          (wsSocket as any).emit("register room", {
            num,
          });
        }
      }
      (wsSocket as any).on("new notification", async (message) => {
        // alert('incoming_textincoming_textincoming_textincoming_text')
        var nt = store.state.dashboard.notifications.find(function (element) {
          return element.id === message._id;
        });
        if (!nt) {
          if (message.message.direction === "in") {
            await store.dispatch("newNotification", message.message);
            const num = message.message.from;

            const contact: any = await getNotificationContact(num);
            message.message.contact = contact;
            store.commit("NEW_INCOMING_TEXT", message.message);
            store.commit("SET_NOTIFICATION_RINGTONE", true);

            var tid = setTimeout(function () {
              store.commit("SET_NOTIFICATION_RINGTONE", false);
            }, 60 * 30);
          } else {
            store.commit("NEW_INCOMING_TEXT", message.message);
          }
        }
      });
      (wsSocket as any).on("other read notification", (message) => {
        store.commit("DELETE_NOTIFICATION", message);
      });
    },

    markNotificationAsRead: (context, payload) => {
      axios.defaults.headers.common.Authorization =
        "Bearer " + context.state.account.jwt;
      /* var nt = context.state.dashboard.notifications
                .filter((e) => (e as any).id == payload.id);*/
      //var nts =  context.state.dashboard.notifications.filter((e) => (e as any).number == payload.number  );
      var nts = context.state.dashboard.notifications.filter(
        (e) => (e as any).number == payload.number && !(e as any).read
      );

      nts.forEach((nt) => {
        (context.state.dashboard.notifications_socket as any).emit(
          "read notification",
          {
            number: payload.socketRoom, // payload.socket_room,
            notificationId: nt.id,
          }
        );
        axios
          .post(`${AppSettings.API_HOST}markNotificationAsRead`, {
            id: nt.id,
            timestamp: nt.timestamp, //   payload.timestamp,
          })
          .then((r) => {});
      });
      context.commit("SET_NOTIFICATION_STATUS");
    },

    //newe code no contact of perticular notifn
    checkNotifications_new: (context, payload) => {
      context.commit("SET_ADMIN_LOADER", true);
      const numbers = [];
      for (const num of context.state.account.text_permissions) {
        if ((num as any).text_permissions_level !== "none") {
          numbers.push((num as any).phone_number as never);
        }
      }
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}checkNotifications`, {
            numbers,
          })
          .then((r) => {
            const notifications = [];
            if (
              r.data !== null &&
              typeof r.data[Symbol.iterator] === "function"
            ) {
              for (const notification of r.data) {
                if (!notification.time) {
                  // notification.time=moment((notification.timestamp - 62167219200) * 1000);//.format("YYYY-MM-DD hh:mma");
                  // notification.times=moment().calendar(notification.time);
                  notification.time = moment(
                    (notification.timestamp - 62167219200) * 1000
                  ).format("YYYY-MM-DD");
                }
                notifications.push(notification as never);
              }

              notifications.sort((a, b) => {
                if (!a.time)
                  a.time = moment((a.timestamp - 62167219200) * 1000); //.format("YYYY-MM-DD hh:mma");
                if (!b.time)
                  b.time = moment((b.timestamp - 62167219200) * 1000); //.format("YYYY-MM-DD hh:mma");
                const date1 = new Date((a as any).time);
                const date2 = new Date((b as any).time);
                return date1 < date2 ? -1 : 1;
              });
              moment.locale("en", {
                calendar: {
                  lastDay: "[Yesterday at] LT",
                  sameDay: "[Today at] LT",
                  sameElse: "DD/MM/YYYY",
                  nextDay: "DD/MM/YYYY",
                  nextWeek: "DD/MM/YYYY",
                  lastWeek: "DD/MM/YYYY",
                },
              });
              notifications.map((o) => {
                o.timeModified = moment(o.time).calendar();
              });
            }
            resolve(notifications.reverse());
          })
          .catch((r) => {
            reject(r);
          });
      });
    },
    // old code which contain contact of perticular notifn
    checkNotifications: (context, payload) => {
      const numbers = [];

      for (const num of context.state.account.text_permissions) {
        if ((num as any).text_permissions_level !== "none") {
          numbers.push((num as any).phone_number as never);
        }
      }
      const num = numbers[0];
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization =
          "Bearer " + context.state.account.jwt;
        axios
          .post(`${AppSettings.API_HOST}checkNotifications`, {
            numbers,
          })
          .then((r) => {
            context.commit("CLEAR_NOTIFICATIONS");
            const notifications = [];
            if (
              r.data !== null &&
              typeof r.data[Symbol.iterator] === "function"
            ) {
              for (const notification of r.data) {
                if (!notification.time)
                  notification.time = moment(
                    (notification.timestamp - 62167219200) * 1000
                  ); //.format("YYYY-MM-DD hh:mma");
                notifications.push(notification as never);
              }

              notifications.sort((a, b) => {
                if (!a.time)
                  a.time = moment((a.timestamp - 62167219200) * 1000); //.format("YYYY-MM-DD hh:mma");
                if (!b.time)
                  b.time = moment((b.timestamp - 62167219200) * 1000); //.format("YYYY-MM-DD hh:mma");
                const date1 = new Date((a as any).time);
                const date2 = new Date((b as any).time);
                return date1 < date2 ? -1 : 1;
              });
              moment.locale("en", {
                calendar: {
                  lastDay: "[Yesterday at] LT",
                  sameDay: "[Today at] LT",
                  sameElse: "YYYY-MM-DD",
                  nextDay: "YYYY-MM-DD",
                  nextWeek: "YYYY-MM-DD",
                  lastWeek: "YYYY-MM-DD",
                },
              });
              notifications.map((o) => {
                o.timeModified = moment(o.time).calendar();
              });
              context.commit("SET_ADMIN_LOADER", false);
              //  store.commit("SET_ADMIN_LOADER", false);
              context.dispatch("getContacts").then((r) => {
                Promise.all(
                  notifications.map((notification) =>
                    context.dispatch("newNotification", notification)
                  )
                );
              });
              return resolve(r.data);
            } else {
              return;
            }
          });
      });
    },
  },
  getters: {
    scheduleButtonDisabled: (state) => {
      const { scheduleForm, currentFiltersHaveRun } = state.reports;
      return (
        !currentFiltersHaveRun ||
        (!scheduleForm.monthlyEnabled &&
          !scheduleForm.dailyEnabled &&
          !scheduleForm.weeklyEnabled) ||
        (scheduleForm.monthlyEnabled &&
          scheduleForm.monthlyDelivery === "none") ||
        (scheduleForm.dailyEnabled && !scheduleForm.dailyTime) ||
        (scheduleForm.weeklyEnabled && scheduleForm.enabledDay === "") ||
        scheduleForm.filename === "" ||
        scheduleForm.email === ""
      );
    },
  },
});

function buildLuceneQuery(includeTimestamp: boolean = true): string[] {
  // Build Lucene Query
  const query = [];
  if (includeTimestamp) {
    var start_date_local = moment(
      store.state.reports.filters.startDate
    ).startOf("day");
    var start_date_utc = moment(start_date_local.clone()).utc();
    var start_date_utc_unix = start_date_utc.unix();

    var end_date_local = moment(store.state.reports.filters.endDate).endOf(
      "day"
    );
    var end_date_utc = moment(end_date_local.clone()).utc();
    var end_date_utc_unix = end_date_utc.unix();

    // tslint:disable-next-line:max-line-length
    // query.push((`startTime=${store.state.reports.filters.startDate ? (store.state.reports.filters as any).startDate.getTime() : ''}` as never));
    // tslint:disable-next-line:max-line-length
    //query.push((`endTime=${store.state.reports.filters.endDate ? (store.state.reports.filters as any).endDate.getTime() : ''}` as never));

    query.push(`startTime=${start_date_utc_unix}`);
    // tslint:disable-next-line:max-line-length
    query.push(`endTime=${end_date_utc_unix}`);
  }

  if (store.state.reports.filters.inboundChecked) {
    if (store.state.reports.filters.outboundChecked) {
      query.push(`call_direction=both` as never);
    } else {
      query.push(`call_direction=inbound` as never);
    }
  } else if (store.state.reports.filters.outboundChecked) {
    query.push(`call_direction=outbound` as never);
  }

  if (store.state.reports.filters.answeredYes) {
    if (!store.state.reports.filters.answeredNo) {
      query.push(`answered=yes` as never);
    }
  } else if (store.state.reports.filters.answeredNo) {
    query.push(`answered=no` as never);
  }

  if (store.state.reports.filters.extensionsList.length > 0) {
    var checkedcount = store.state.reports.filters.extensionsList.reduce(
      function (n, elm) {
        return n + elm.value;
      },
      0
    );
    const checkedExtensions = store.state.reports.filters.extensionsList
      .filter((e) => (e && (e as any).value) || checkedcount === 0) // if nothing select assume all selected
      .reduce((p: string[], c) => {
        if ((c as any).ext) {
          p.push((c as any).ext);
        }
        if ((c as any).external) {
          p.push((c as any).external);
        }
        return p;
      }, [])
      .map((e) => e.replace(/\s/g, ""))
      .join(",");
    if (checkedExtensions.length > 0) {
      query.push(`extensions=${checkedExtensions}` as never);
    }
  }

  if (store.state.reports.filters.assignedUserIds.length > 0) {
    query.push(
      `users=${store.state.reports.filters.assignedUserIds.join(",")}` as never
    );
  }

  return query;
}

function transformExtensionList(eList: { [key: string]: any }): Extension[] {
  const output = [] as Extension[];
  let assignedUserIds = [] as string[];
  Object.keys(eList).forEach((key) => {
    const elem = {
      ext: key,
      external: eList[key].external && eList[key].external.replace("+", "*"),
      value: eList[key].selected,
    };
    assignedUserIds.push(eList[key].userId);
    output.push(elem);
  });
  assignedUserIds = assignedUserIds.filter((id) => id !== null);
  store.commit("UPDATE_ASSIGNED_USER_IDS", {
    assignedUserIds,
  });
  return output;
}

function getFilters(
  filterState: ReportsFilters,
  email: string
): ReportDataFilters {
  let answeredSum = 0;
  // const { answeredNo, answeredYes, inboundChecked, outboundChecked, extensionsList } = filterState;
  const {
    answeredNo_schedule,
    answeredYes_schedule,
    inboundChecked_schedule,
    outboundChecked_Schedule,
    extensionsList_schedul,
  } = filterState;
  // answeredSum += answeredNo ? 1 : 0;
  // answeredSum += answeredYes ? 2 : 0;
  answeredSum += answeredNo_schedule ? 1 : 0;
  answeredSum += answeredYes_schedule ? 2 : 0;
  const answered =
    answeredSum <= 1 ? "false" : answeredSum === 2 ? "true" : "both";
  let directionSum = 0;
  directionSum += inboundChecked_schedule ? 1 : 0;
  directionSum += outboundChecked_Schedule ? 2 : 0;

  const callDirection = (() => {
    switch (directionSum) {
      case 1:
        return "inbound";
      case 2:
        return "outbound";
      case 3:
        return "both";
      case 0:
      default:
        return "false";
    }
  })();

  return {
    answered,
    call_direction: callDirection,
    extensions: extensionsList_schedul.filter((e) => e.value).map((e) => e.ext),
    email_address: email,
  };
}

function timedCount() {
  // document.getElementById("txt").value = c;
  this.$data.c = this.$data.c + 1;
  console.log(this.$data.c);
  this.$data.t = setTimeout(this.timedCount, 1000);
}

function startCount() {
  if (!this.$data.timer_is_on) {
    this.$data.timer_is_on = 1;
    this.timedCount();
  }
}

// var timerids= [];
// function verifyToken (context,_jwt)
// {
//     timerids.pop();
//     axios.defaults.headers.common.Authorization = 'Bearer ' + _jwt;
//     return axios.get(`${AppSettings.API_HOST}verifyJWT`)
//     .then((r) =>
//      {
//         if (timerids.length===0)
//         {
//             var tkn=_jwt;
//             var tid=  setTimeout(function(){
//                     verifyToken(context,tkn) ;
//                   //  store.commit('LOGOUT_STATUS' , true);
//           }, 60000*30);
//        // }, 8000);
//             timerids.push(tid);
//         }
//     }).catch((failResponse) => {
//          store.dispatch('relogin',  context.state.account.encrypted_creds);
//        ;
//        // store.commit('LOGOUT_SUCCESS');
//         //router.push("/login");
//     });
// }
var timerids = [];
function verifyToken(context, _jwt) {
  timerids.pop();
  axios.defaults.headers.common.Authorization = "Bearer " + _jwt;
  return axios
    .get(`${AppSettings.API_HOST}verifyJWT`)
    .then((r) => {
      console.log("verified");
    })
    .catch((failResponse) => {
      console.log("failed authenticate");
      const payload = {
        creds: context.state.account.encrypted_creds,
        account_name: context.state.account.account_name,
      };
      store.dispatch("relogin", payload);
      // store.commit('LOGOUT_SUCCESS');
      //router.push("/login");
    });
}

function getFrequency(
  scheduleFormState: ScheduleFormFields,
  timezone: Timezone
): ReportDataFrequency {
  let rate: "daily" | "weekly" | "monthly" = "daily";
  let hour = 0;
  // tslint:disable-next-line:max-line-length
  const {
    dailyEnabled,
    dailyTime,
    weeklyEnabled,
    weeklyTime,
    monthlyEnabled,
    monthlyTime,
    monthlyDelivery,
    enabledDay,
    WeeklyDays_EnalbeList,
  } = scheduleFormState;
  // const month = -1;
  if (dailyEnabled) {
    rate = "daily";
    if (dailyTime instanceof Date) {
      hour = (dailyTime as Date).getHours();
    }
  } else if (weeklyEnabled) {
    rate = "weekly";
    if (weeklyTime) {
      hour = weeklyTime.getHours();
    }
  } else if (monthlyEnabled) {
    rate = "monthly";
    if (monthlyTime) {
      hour = monthlyTime.getHours();
    }
  }
  let dayOfMonth = -1;
  const dayOfWeek = [];
  const dayOfWeek_ = [];

  if (rate === "weekly") {
    WeeklyDays_EnalbeList.forEach((nt) => {
      if (nt.value) {
        dayOfWeek_.push(nt.day as never);
      }
    });

    // switch (enabledDay) {
    //     case('sunday'):
    //         dayOfWeek.push(('sun') as never);
    //         break;
    //     case('monday'):
    //         dayOfWeek.push(('mon') as never);
    //         break;
    //     case('tuesday'):
    //         dayOfWeek.push(('tues') as never);
    //         break;
    //     case('wednesday'):
    //         dayOfWeek.push(('wed') as never);
    //         break;
    //     case('thursday'):
    //         dayOfWeek.push(('thurs') as never);
    //         break;
    //     case('friday'):
    //         dayOfWeek.push(('fri') as never);
    //         break;
    //     case('saturday'):
    //         dayOfWeek.push(('sat') as never);
    //         break;
    //     default:
    //         break;
    // }
  } else if (rate === "monthly") {
    switch (monthlyDelivery) {
      case "first":
        dayOfMonth = 1;
        break;
      case "fifteenth":
        dayOfMonth = 15;
        break;
      case "last":
        dayOfMonth = -1;
        break;
    }
  }
  return {
    day_of_month: dayOfMonth,
    day_of_week: dayOfWeek_, //dayOfWeek,
    hour,
    rate,
    timezone: timezone.abbrev,
  };
}

function processSttendeeStopTalking(jsonData: any) {
  var conference_channel_vars = jsonData.data.conference_channel_vars;
  var targetobject = store.state.dashboard.ConferecneParticipantList.find(
    function (element) {
      return element.member_id === conference_channel_vars.member_id;
    }
  );
  targetobject.talking = false;
}

function processSttendeeStartTalking(jsonData: any) {
  var conference_channel_vars = jsonData.data.conference_channel_vars;
  var targetobject = store.state.dashboard.ConferecneParticipantList.find(
    function (element) {
      return element.member_id === conference_channel_vars.member_id;
    }
  );
  targetobject.talking = true;
}

function processAttendeeRemove(jsonData: any) {
  var arr = store.state.dashboard.ConferecneParticipantList;
  var conference_channel_vars = jsonData.data.conference_channel_vars;
  var memberid = conference_channel_vars.member_id;
  var removeIndex = arr
    .map(function (item) {
      return item.member_id;
    })
    .indexOf(memberid);
  // remove object
  if (removeIndex >= 0)
    store.state.dashboard.ConferecneParticipantList.splice(removeIndex, 1);
  store.state.dashboard.Confrence_On =
    store.state.dashboard.ConferecneParticipantList.length > 0;
}

function processConferenceCall(jsonData: any, AttendeeSectionList: any) {
  // alert('processConferenceCall');

  var member_name = AttendeeSectionList.Users.find(function (element) {
    return element.id === jsonData.data.custom_channel_vars.owner_id;
  });

  var _confrenceuser =
    typeof member_name === "undefined"
      ? jsonData.caller_id_name
      : member_name.label;
  var conference_member_data = jsonData.data;
  var conference_channel_vars = jsonData.data.conference_channel_vars;
  // var name  =conference_member_data.custom_channel_vars.original_number ?
  // conference_member_data.custom_channel_vars.original_number :conference_member_data.caller_id_name;
  var name = _confrenceuser;
  var number = conference_member_data.custom_channel_vars.original_number
    ? conference_member_data.custom_channel_vars.original_number
    : conference_member_data.caller_id_number;

  var namearr = name.split(" ");
  var Fname_L = namearr[0].substring(0, 1);
  var Lname_L = namearr.length > 1 ? namearr[1].substring(0, 1) : " ";
  var vrandomcolor = "";
  vrandomcolor = "hsl(" + Math.round(Math.random() * 359) + ",100%,50%)"; //'#000000'.slice(0, -color.length) + color;
  var styleobj = { "background-color": vrandomcolor };

  var conferecneparticipantobjet: ConferecneParticipant = {
    name: name,
    code: Fname_L + Lname_L,
    number: number,
    speak: conference_channel_vars.speak,
    hear: conference_channel_vars.hear,
    duration: 0, //this.alterTime(pdur),
    talking: false,
    member_id: conference_channel_vars.member_id,
    colorcode: styleobj,
  };

  let ms: any = moment.duration(conferecneparticipantobjet.duration, "seconds");
  setInterval(() => {
    var result = (ms as any).format("dd:hh:mm:ss");
    if (!isNaN(result)) result = "00:" + result;
    result;
    conferecneparticipantobjet.duration = result; //(ms as any).format("dd:hh:mm:ss");// this.alterTime(ms);
    ms._milliseconds += 1000;
  }, 1000);
  store.commit("ADD_CONFERENCE_PARTICIPANT_LIST", conferecneparticipantobjet);
}

function processCall(jsonData: object) {
  var data = (jsonData as any).data;
  store.commit("SET_ONGOING_CALLS", data);
}

function endCall(event: object) {
  const data = (event as any).data;
  store.commit("SET_ONGOING_CALLS", data);
}
if (isElectron()) {
  ipcRenderer.on("end-call", (event, arg) => {
    endCall(arg.jsonData);
  });

  ipcRenderer.on("loadContactFromNotification", (event, arg) => {
    processCall(arg.jsonData);
  });
}

function noteSort(a, b) {
  if (a.last_updated === b.last_updated) {
    return 0;
  }
  return a.last_updated > b.last_updated ? -1 : 1;
}

function processTexts(r) {
  const messageHistory = [];
  const l1 = r.data.call1.messages.length;
  const l2 = r.data.call2.messages.length;
  const len = l1 + l2;
  // These indexes will count up as messages from each call
  // get added to the text_history
  let c1Index = 0;
  let c2Index = 0;
  // The final history will be at most 25 messages long

  for (let i = 0; i < len; i++) {
    // If we have used every message from the first call
    // then the remaining messages can all come from the second
    if (c1Index === l1) {
      for (let j = c2Index; j < l2; j++) {
        messageHistory.push({
          id: r.data.call2.messages[j].id,
          content: r.data.call2.messages[j].text,
          time: r.data.call2.messages[j].time,
          direction: "in",
        } as never);
      }
      return messageHistory;
    }
    // Same deal but for the second call
    if (c2Index === l2) {
      for (let j = c1Index; j < l1; j++) {
        messageHistory.push({
          id: r.data.call1.messages[j].id,
          content: r.data.call1.messages[j].text,
          time: r.data.call1.messages[j].time,
          direction: "out",
        } as never);
      }
      return messageHistory;
    }
    // Compare the timestamps for the two messages, add the most
    // recent message and increment the appropriate index
    const d1 = new Date(r.data.call1.messages[c1Index].time);
    const d2 = new Date(r.data.call2.messages[c2Index].time);
    if (d1 > d2) {
      messageHistory.push({
        id: r.data.call1.messages[c1Index].id,
        content: r.data.call1.messages[c1Index].text,
        time: r.data.call1.messages[c1Index].time,
        direction: "out",
      } as never);
      c1Index++;
    } else {
      messageHistory.push({
        id: r.data.call2.messages[c2Index].id,
        content: r.data.call2.messages[c2Index].text,
        time: r.data.call2.messages[c2Index].time,
        direction: "in",
      } as never);
      c2Index++;
    }
  }
  return messageHistory;
}

async function getVoicemailContact(num) {
  var callername: any = await getNotificationContact(num);
  callername = `${callername.first_name} ${callername.last_name}`;
  return callername;
}
function getNotificationContact(num) {
  return new Promise((resolve, reject) => {
    for (const contact of store.state.dashboard.contacts) {
      if ((contact as any).numbers && (contact as any).numbers.main) {
        for (const phoneNum of (contact as any).numbers.main) {
          if (num === phoneNum) {
            resolve(contact);
            //return;
          }
        }
      }
      if (
        (contact as any).numbers.mobile &&
        (contact as any).numbers.mobile.number
      ) {
        if ((contact as any).numbers.mobile.number === num) {
          resolve(contact);
          //return;
        }
      }
    }
    return resolve({
      first_name: num,
      last_name: "",
      contact_status: "new_contact",
    });
    /*  store.dispatch('addNotificationContact', num).then((r) => {
            //store.commit('ADD_CONTACTS', [r]);
            resolve(r);
        });*/
  });
}
export function isElectron() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf(" electron/") > -1) {
    return true;
  }
  return false;
}

async function replayAction(action, payload) {
  console.log("action", action);
  console.log("payload", payload);
  if (isElectron()) {
    const creds = (ipcRenderer as any).sendSync("get-creds");
    await store.dispatch("relogin", creds);
    store.dispatch(action, payload);
  } else {
    store.commit("LOGOUT_SUCCESS");
    console.log("replayAction logout");
    router.push("/login");
  }
}
